import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ImagePool } from '../device-control/device-screen/image-pool';
import { VendorUtilService } from 'src/app/services/vendor-util.service';
import { ScalingService } from 'src/app/services/scaling.service';
import { ControlService } from 'src/app/services/control.service';
import { StorageService } from 'src/app/services/storage.service';
import { LoginService } from 'src/app/services/login.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InstallService } from 'src/app/services/install.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { GroupService } from 'src/app/services/group.service';
import { DeviceColumnService } from 'src/app/services/device-column.service';
import { DeviceService } from 'src/app/services/device.service';
import { AutomationService } from 'src/app/services/automation.service';
import { StandaloneService } from 'src/app/services/standalone.service';
import { StackService } from 'src/app/services/stack-service.service';
import { LogcatService } from 'src/app/services/logcat.service';
import { firstValueFrom, first } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import io, { Socket as SocketIOClient } from 'socket.io-client';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { param } from 'jquery';
import { EncryptionDecryptionService } from 'src/app/services/encryption-decryption.service';
import * as pako from 'pako';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-multi-execution',
  templateUrl: './multi-execution.component.html',
  styleUrls: ['./multi-execution.component.css'],
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule]
})
export class MultiExecutionComponent implements OnInit, AfterViewInit, OnChanges {
  @Output() fullViewExit = new EventEmitter<boolean>();
  @ViewChild('screenshotAlert') alertTemplate: TemplateRef<any>;
  @ViewChild('AppUpload') appInstallTemplate: TemplateRef<any>;
  deviceCount: number = 0;
  device: any;
  control: any;
  private listeners: { [key: string]: EventListener } = {};
  modalRef!: MatDialogRef<any>;
  aboutDevice: boolean = false;
  wsAppium: any;
  ws: WebSocket; // Added declaration for ws
  element: HTMLElement;
  screen: any;
  cssTransform: any;
  canvasAspect: number;
  isScreenRotated: boolean = false;
  loader: boolean = true;
  cursor: string = 'wait';
  displayError: any;
  BLANK_IMG: any;
  URL: any;
  scaler: any;
  prevCoords: { x?: number; y?: number } = {};
  input: HTMLInputElement;
  value: any;
  currentUser: any;
  email: any;
  msg: string;
  appInstalling: boolean = false;
  progress: number = 0;
  screenRecord: boolean = false;
  bridgeHost: any;

  //for device1
  isScreenRotated1: boolean = false;
  cursor1: string = 'wait';
  loader1: boolean = true;
  cssTransform1: any;
  aboutDevice1: boolean = false;
  control1: any
  prevCoords1: { x?: number; y?: number } = {};
  scaler1: any;
  input1: HTMLInputElement;
  private listeners1: { [key: string]: EventListener } = {};
  element1: HTMLElement;
  ws1: WebSocket;
  canvasAspect1: number;
  BLANK_IMG1: any;
  displayError1: any;
  screen1: any;
  device1: any;

  //for device2
  isScreenRotated2: boolean = false;
  cursor2: string = 'wait';
  loader2: boolean = true;
  cssTransform2: any;
  aboutDevice2: boolean = false;
  control2: any
  prevCoords2: { x?: number; y?: number } = {};
  scaler2: any;
  input2: HTMLInputElement;
  private listeners2: { [key: string]: EventListener } = {};
  element2: HTMLElement;
  ws2: WebSocket;
  canvasAspect2: number;
  BLANK_IMG2: any;
  displayError2: any;
  screen2: any;
  device2: any;

  //for device3
  isScreenRotated3: boolean = false;
  cursor3: string = 'wait';
  loader3: boolean = true;
  cssTransform3: any;
  aboutDevice3: boolean = false;
  control3: any
  prevCoords3: { x?: number; y?: number } = {};
  scaler3: any;
  input3: HTMLInputElement;
  private listeners3: { [key: string]: EventListener } = {};
  element3: HTMLElement;
  ws3: WebSocket;
  canvasAspect3: number;
  BLANK_IMG3: any;
  displayError3: any;
  screen3: any;
  device3: any;

  //for device4
  isScreenRotated4: boolean = false;
  cursor4: string = 'wait';
  loader4: boolean = true;
  cssTransform4: any;
  aboutDevice4: boolean = false;
  control4: any
  prevCoords4: { x?: number; y?: number } = {};
  scaler4: any;
  input4: HTMLInputElement;
  private listeners4: { [key: string]: EventListener } = {};
  element4: HTMLElement;
  ws4: WebSocket;
  canvasAspect4: number;
  BLANK_IMG4: any;
  displayError4: any;
  screen4: any;
  device4: any;

  packageName: string;
  list: any;
  items: any;
  prefix = 'd' + Math.floor(Math.random() * 1000000) + '-';
  priorityOrder = {
    'Stop Using': 0,
    'Use': 1,
    'Preparing': 2,
    'Ready': 3,
    'Busy': 4,
    'Connected': 5,
    'Unauthorized': 6,
    'Stop Automation': 7,
    'Offline': 8,
    'Disconnected': 9,
    'Unknown': 10
    // 'Unknown': 0,
    // 'Disconnected': 1,
    // 'Offline': 2,
    // 'Stop Automation': 3,
    // 'Unauthorized': 4,
    // 'Connected': 5,
    // 'Busy': 6,
    // 'Ready': 7,
    // 'Preparing': 8,
    // 'Use': 9,
    // 'Stop Using': 10
  };
  activeColumns = [];
  activeFilters = [];
  activeSorting = [];
  columnDefinitions: any;

  mapping = {
    0: {
      0: 0
      , 90: -90
      , 180: -180
      , 270: 90
    }
    , 90: {
      0: 90
      , 90: 0
      , 180: -90
      , 270: 180
    }
    , 180: {
      0: 180
      , 90: 90
      , 180: 0
      , 270: -90
    }
    , 270: {
      0: -90
      , 90: -180
      , 180: 90
      , 270: 0
    }
  }
  tracker: TrackerService;
  showThrottleOptions: boolean = false;
  throttleOptions: { label: string, value: number }[] = [
    { label: 'No limit', value: 0 },
    { label: '128kbps', value: 16000 },
    { label: '256kbps', value: 32000 },
    { label: '1mbps', value: 125000 },
    { label: '5mbps', value: 625000 },
    { label: '15mbps', value: 1875000 }
  ];
  toggleStates: { [key: string]: boolean } = {};

  constructor(
    private elementRef: ElementRef,
    private route: ActivatedRoute,
    private router: Router,
    private vendorUtilService: VendorUtilService,
    private storageService: StorageService,
    private scalingService: ScalingService,
    private renderer: Renderer2,
    private controlService: ControlService,
    private loginService: LoginService,
    private dialog: MatDialog,
    private standaloneService: StandaloneService,
    private stackService: StackService,
    private logcatService: LogcatService,
    private installService: InstallService,
    private groupService: GroupService,
    private settingsService: SettingsService,
    private deviceColumnService: DeviceColumnService,
    private deviceService: DeviceService,
    private automationService: AutomationService,
    private encryptionDecryptionService: EncryptionDecryptionService,
    private commonService: CommonService
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit(): void {
    this.packageName = sessionStorage.getItem('packageName');
    this.route.params.subscribe(async params => {
      try {
        // Get both devices
        this.device = await this.getDevice(params['id']);
        console.log(this.device)

        // Check if both devices were loaded successfully
        if (this.device) {
          this.scaler = this.scalingService.coordinator(
            this.device.display.width
            , this.device.display.height
          );
          this.control = this.controlService.create(this.device, this.device.channel);
        } else {
          console.error('Failed to load one or both devices');
          // Handle the error, maybe navigate back or show an error message
        }
      } catch (error) {
        console.error('Error in device loading:', error);
        // Handle the error
      }
    });


    window.onbeforeunload = null;
    this.email = this.currentUser.email;
    this.URL = window.URL || window.webkitURL;
    this.BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.cssTransform = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.cssTransform1 = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.cssTransform2 = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.cssTransform3 = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.cssTransform4 = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.isScreenRotated = false;
    this.isScreenRotated1 = false;
    this.isScreenRotated2 = false;
    this.isScreenRotated3 = false;
    this.isScreenRotated4 = false;
    this.element = this.elementRef.nativeElement.firstElementChild.children[1];//mobileScreen div
    this.displayError = false;
    this.input = this.element.querySelector('input');

    this.screen = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.screen1 = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.screen2 = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.screen3 = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.screen4 = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    //for multi device
    this.BLANK_IMG1 = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.BLANK_IMG2 = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.BLANK_IMG3 = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.BLANK_IMG4 = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.tracker = this.deviceService.trackAll();
    this.columnDefinitions = this.deviceColumnService.columnDefinitions;
  }

  ngOnChanges(changes: SimpleChanges) {



    // Watch for column updates
    if (changes['columns'] && !changes['columns'].firstChange) {
      const newValue = changes['columns'].currentValue as { name: string, selected: boolean }[];
      this.updateColumns(newValue);
    }

    // Watch for filter updates.
    if (changes['filter']) {

      this.list = this.elementRef.nativeElement.querySelector('ul');
      this.items = Array.from(this.list.children) as Element[];

      const newValue = changes['filter'].currentValue;

      this.updateFilters(newValue);
      // setTimeout(() => {

      //   this.updateFilters(newValue);
      // }, 500);

    }
  }

  async ngAfterViewInit() {
    this.route.params.subscribe(async params => {
      try {
        // Get slave devices
        let slaveSerials = params['encryptedDevices'];
        let slaveDevices = this.encryptionDecryptionService.decryptDeviceSerials(slaveSerials);
        this.deviceCount = slaveDevices.length + 1;
        console.log("Slave devices serials array:\n", slaveDevices);

        this.device1 = await this.getDevice(slaveDevices[0]);
        this.device2 = await this.getDevice(slaveDevices[1]);
        this.device3 = await this.getDevice(slaveDevices[2]);
        this.device4 = await this.getDevice(slaveDevices[3]);
        console.log("All ", this.deviceCount, " slave devices\n", await this.device1, await this.device2, await this.device3, await this.device4);
        //for first device
        this.methodOne();
        this.keyboardHandlingMethod();
        this.touchHandlingMethod();
        //for first slave device
        const currentUser: any = this.currentUser.userObj;
        const groupId = currentUser.groups.subscribed[0];
        //for first slave device
        this.checkGroupValidation1(groupId, this.device1.serial);
        //for second slave device
        this.checkGroupValidation2(groupId, this.device2.serial);
        //for third slave device
        this.checkGroupValidation3(groupId, this.device3.serial);
        //for fourth slave device
        this.checkGroupValidation4(groupId, this.device4.serial);

      } catch (error) {
        console.error('Error in device loading:', error);
        // Handle the error
      }
    });
    //code to open the desired package
    setTimeout(() => {
      let command = 'monkey -p ' + this.packageName + ' -c android.intent.category.LAUNCHER 1'
      this.control.shell(command)
      this.control1.shell(command)
      this.control2.shell(command)
      this.control3.shell(command)
      this.control4.shell(command);
    }, 7000);
  }

  checkGroupValidation1(groupId: any, deviceSerial: any) {
    //for new backend

    this.automationService.validationUsersAsPerGroupMultiDevice(groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        this.device1.using = true;
        this.device1.state = "using";
        this.control1 = this.controlService.create(this.device1, this.device1.channel);
        this.deviceService.trackAll();
        this.deviceService.trackGroup();
        setTimeout(() => {
          this.methodOneDevice1();
          // this.touchHandlingMethod1();
          // this.keyboardHandlingMethod1();
        }, 2000)
        // window.open('#!/control/' + deviceSerial, "_self");
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

  checkGroupValidation2(groupId: any, deviceSerial: any) {
    //for new backend

    this.automationService.validationUsersAsPerGroupMultiDevice(groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        this.device2.using = true;
        this.device2.state = "using";
        this.control2 = this.controlService.create(this.device2, this.device2.channel);
        this.deviceService.trackAll();
        this.deviceService.trackGroup();
        setTimeout(() => {
          this.methodOneDevice2();
          // this.touchHandlingMethod1();
          // this.keyboardHandlingMethod1();
        }, 2000)
        // window.open('#!/control/' + deviceSerial, "_self");
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

  checkGroupValidation3(groupId: any, deviceSerial: any) {
    //for new backend

    this.automationService.validationUsersAsPerGroupMultiDevice(groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        this.device3.using = true;
        this.device3.state = "using";
        this.control3 = this.controlService.create(this.device3, this.device3.channel);
        this.deviceService.trackAll();
        this.deviceService.trackGroup();
        setTimeout(() => {
          this.methodOneDevice3();
          // this.touchHandlingMethod1();
          // this.keyboardHandlingMethod1();
        }, 2000)
        // window.open('#!/control/' + deviceSerial, "_self");
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

  checkGroupValidation4(groupId: any, deviceSerial: any) {
    //for new backend

    this.automationService.validationUsersAsPerGroupMultiDevice(groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        this.device4.using = true;
        this.device4.state = "using";
        this.control4 = this.controlService.create(this.device4, this.device4.channel);
        this.deviceService.trackAll();
        this.deviceService.trackGroup();
        setTimeout(() => {
          this.methodOneDevice4();
          // this.touchHandlingMethod1();
          // this.keyboardHandlingMethod1();
        }, 2000)
        // window.open('#!/control/' + deviceSerial, "_self");
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

  async getDevice(serial: string): Promise<any> {
    try {
      const device: any = await firstValueFrom(this.deviceService.get(serial));

      // Your existing code for stack, invited device, etc.
      let stack = this.stackService.getStack();
      if (stack.includes(device.serial)) {
        this.stackService.delete(device.serial);
        this.stackService.push(device.serial);
      } else {
        this.stackService.push(device.serial);
      }

      const invitedDevice = this.groupService.invite(device);
      // this.device1 = device;
      // this.device1.using = true;
      // this.device1.state = "using";
      // this.control1 = this.controlService.create(device, device.channel);

      this.settingsService.set('lastUsedDevice', serial);

      return device;
    } catch (error) {
      console.error('Error getting device:', error);
      // Return null or a default device object, don't leave it undefined
      return null;
    }
  }

  inviteDevice(device) {
    // return GroupService.invite(device).then(function () {
    //   scope.$digest()
    // })
  }

  kickDevice(device: any, force?: boolean) {

    this.stackService.delete(device.serial);
    if (Object.keys(this.logcatService.deviceEntries).includes(device.serial)) {
      this.logcatService.deviceEntries[device.serial].allowClean = true;

      this.bridgeHost = device.providerUrl;
      this.automationService.stopAppInspector('', device.serial, this.bridgeHost).subscribe((res: any) => {

        sessionStorage.setItem("appInspectorUrl", null);
      });
    }

    // this.Router.navigate(['/devices']);

    // this.logcatService.allowClean = true;   // dont know what this is
    // $rootScope.LogcatService = this.logcatService; // Not sure what the equivalent would be in Angular

    return this.groupService.kick(device, force).catch((e: any) => {
      this.msg = "Device kicked from the group";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Device kicked from the group');
      throw new Error(e);
    });
  }

  addListener = (device: any) => {

    let item = this.createItem(device);


    this.filterItem(item, device);
    this.insertItem(item, device);
  };

  // Triggers when the tracker notices that a device changed.
  changeListener(device) {

    let id = this.calculateId(device)
    let item = this.list.children[id]


    if (item) {
      // First, update columns
      this.updateItem(item, device)

      // Maybe the item is not sorted correctly anymore?
      let diff = this.compareItem(item, device)


      if (diff !== 0) {
        // Because the item is no longer sorted correctly, we must
        // remove it so that it doesn't confuse the binary search.
        // Then we will simply add it back.
        this.list.removeChild(item)
        this.insertItem(item, device)
      }
    }
  }

  // Triggers when a device is removed entirely from the tracker.
  removeListener(device) {


    let id = this.calculateId(device)
    let item = this.list.children[id]

    if (item) {
      this.list.removeChild(item)
    }
    delete this.mapping[id]
  }

  calculateId(device) {
    return this.prefix + device.serial
  }

  createItem(device: any) {
    let id = this.calculateId(device)
    let item = this.build();

    item.id = id;


    this.update(item, device)
    this.mapping[id] = device

    return item
  }

  build(): HTMLLIElement {


    const li = document.createElement('li');
    // aliceblue
    this.renderer.setStyle(li, 'background-color', 'white');
    this.renderer.setStyle(li, 'width', '10em');
    this.renderer.setStyle(li, 'margin', '0');
    this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    //for box shadows in device list icons
    this.renderer.listen(li, 'mouseenter', () => {
      this.renderer.setStyle(li, 'box-shadow', '6px 6px 4px rgba(0, 0, 0, 0.2)');
    });
    this.renderer.listen(li, 'mouseleave', () => {
      this.renderer.removeStyle(li, 'transform');
      this.renderer.setStyle(li, 'box-shadow', '2px 2px 4px #88898d');
    });
    this.renderer.listen(li, 'mousedown', () => {
      this.renderer.setStyle(li, "transform", "translateY(4px)");
      // this.renderer.setStyle(li, "transform", "translateX(4px)");
    });
    li.className = 'cursor-select pointer thumbnail';
    // the whole li is a link
    const a = document.createElement('a');
    li.appendChild(a);

    // .device-photo-small
    const photo = document.createElement('div');
    photo.className = 'device-photo-small';
    const img = document.createElement('img');
    photo.appendChild(img);
    a.appendChild(photo);

    // .device-name
    const name = document.createElement('div');
    name.className = 'device-name';
    this.renderer.setStyle(name, 'color', 'unset')
    name.appendChild(document.createTextNode(''));
    a.appendChild(name);

    // button
    const button = document.createElement('button');
    this.renderer.setStyle(button, 'white-space', 'nowrap')
    button.appendChild(document.createTextNode(''));
    a.appendChild(button);
    //new
    // li.appendChild(button);

    return li;
  }

  filterItem(item, device) {



    if (this.match(device)) {
      item.classList.remove('filter-out')

      if (item.className === 'cursor-select pointer thumbnail' || item.className === 'cursor-select pointer thumbnail device-is-busy') {
        item.style.display = ''

      }

    }
    else {
      item.classList.add('filter-out')

      if (item.className === 'cursor-select pointer thumbnail device-is-busy filter-out' || item.className === 'cursor-select pointer thumbnail filter-out') {



        item.style.display = 'none';
      }
      else {
        item.style.display = ''
      }
    }

  }

  // Compares an item to its siblings to see if it's still in the correct
  // position. Returns <0 if the device should actually go somewhere
  // before the previous item, >0 if it should go somewhere after the next
  // item, or 0 if the position is already correct.
  compareItem(item, device) {
    let prev = item.previousSibling
    let next = item.nextSibling
    let diff

    if (prev) {
      diff = this.compare(device, this.mapping[prev.id])
      if (diff < 0) {
        return diff
      }
    }

    if (next) {
      diff = this.compare(device, this.mapping[next.id])
      if (diff > 0) {
        return diff
      }
    }

    return 0
  }

  //updated compare function
  compare(deviceA: any, deviceB: any) {
    const mapping = {
      asc: 1,
      desc: -1
    };

    let diff: number;

    // First check the priority based on enhancedStateAction
    const textA = deviceA.enhancedStateAction;
    const textB = deviceB.enhancedStateAction;

    // Default to highest possible priority number
    let priorityA = Object.keys(this.priorityOrder).length;
    let priorityB = Object.keys(this.priorityOrder).length;

    // Find matching priorities
    for (const [key, value] of Object.entries(this.priorityOrder)) {
      if (textA.includes(key)) priorityA = value;
      if (textB.includes(key)) priorityB = value;
    }

    // If priorities are different, return their difference
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // If priorities are equal, continue with other sorting criteria
    // for (let i = 0, l = this.activeSorting.length; i < l; ++i) {
    //   const sort = this.activeSorting[i];
    //   diff = this.columnDefinitions[sort.name].compare(deviceA, deviceB);
    //   if (diff !== 0) {
    //     diff *= mapping[sort.order];
    //     break;
    //   }
    // }

    return diff;
  }

  // Updates visible columns. This method doesn't necessarily have to be
  // the fastest because it shouldn't get called all the time.
  updateColumns(columnSettings) {
    let newActiveColumns = []

    // Check what we're supposed to show now
    columnSettings.forEach(function (column) {
      if (column.selected) {
        newActiveColumns.push(column.name)
      }
    })

    // Figure out the patch
    let patch = this.patchArray(this.activeColumns, newActiveColumns)

    // Set up new active columns
    this.activeColumns = newActiveColumns

    return this.patchAll(patch)
  }


  // Updates all the columns in the item. Note that the item must be in
  // the right format already (built with createItem() and patched with
  // patchItem() if necessary).
  updateItem(item, device) {
    let id = this.calculateId(device)
    // if(device.present==true && device.usable)
    // {

    //   device.enhancedStateAction='Use'
    // }
    item.id = id
    this.update(item, device)

    return item
  }

  update(li: any, device: any) {
    let a = li.firstChild
    let img = a.firstChild.firstChild
    let name = a.firstChild.nextSibling
    let nt = name.firstChild
    let button = name.nextSibling

    if (device.enhancedStateAction == "Stop Using") {
      console.log(this.currentUser.userObj.privilege, "this.currentUser");
      if (device.owner?.name !== "admin") {
        if (this.currentUser.userObj.privilege == "admin") {
          this.renderer.setStyle(button, 'background-color', '#ff6426');
          this.renderer.setStyle(button, 'color', 'Black');
        } else {
          this.renderer.setStyle(button, 'background-color', '#167ffc');
          this.renderer.setStyle(button, 'color', 'white');
        }
      } else {
        this.renderer.setStyle(button, 'background-color', '#167ffc');
        this.renderer.setStyle(button, 'color', 'white');
      }
    }
    else if (device.enhancedStateAction == "Preparing") {
      this.renderer.setStyle(button, 'color', 'rgb(255 255 255)');
      this.renderer.setStyle(button, 'background-color', 'rgb(41 121 1)');
    }
    else {
      this.renderer.setStyle(button, 'background-color', '#eaeaea');
      this.renderer.setStyle(button, 'color', '#555');
    }
    let at = button.firstChild

    let classes = 'btn btn-xs device-status '


    // .device-photo-small
    if (img.getAttribute('src') !== device.enhancedImage120 || device.ios) {
      img.setAttribute('src', device.enhancedImage120)
    }

    // .device-name
    nt.nodeValue = device.enhancedName;

    // button
    at.nodeValue = device.enhancedStateAction;

    let getStateClasses = (state) => {
      let stateClasses = {
        using: 'state-using btn-primary',
        busy: 'state-busy btn-warning',
        available: 'state-available btn-outline-primary',
        ready: 'state-ready btn-outline-primary',
        present: 'state-present btn-outline-primary',
        preparing: 'state-preparing btn-outline-primary btn-outline-success',
        unauthorized: 'state-unauthorized btn-outline-danger',
        offline: 'state-offline btn btn-light',
        automation: 'state-automation btn btn-light'
      }[state]
      if (typeof stateClasses === 'undefined') {
        stateClasses = 'btn btn-light'
      }
      return stateClasses
    }


    //stop-using button click  idar sai bhi call hota hai
    if (getStateClasses(device.state) === 'state-using btn-primary') {
      button.addEventListener('click', () => {
        this.groupService.kick(device);

        // this.Router.navigate(['devices']);
      });

    }


    button.className = classes + getStateClasses(device.state);

    if (device.state === 'available') {
      name.classList.add('state-available')
    } else {
      name.classList.remove('state-available')
    }

    if (device.usable && !device.using) {
      //a.href = '#!/control/' + device.serial
      // a.href = '';
      li.classList.remove('device-is-busy')
    }
    else if (device.using && device.usable) {
      // a.href = '#!/control/' + device.serial
      //a.href = '';

    }
    else {
      a.removeAttribute('href')
      li.classList.add('device-is-busy')
    }
    return li
  }

  // Updates filters on visible items.
  updateFilters(filters) {
    this.activeFilters = filters;
    return this.filterAll();
  }

  // Applies filteItem() to all items.
  filterAll() {


    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.filterItem(this.items[i], this.mapping[this.items[i].id])
    }

  }

  // Checks whether the device matches the currently active filters.
  match(device) {



    for (let i = 0, l = this.activeFilters.length; i < l; ++i) {
      let filter = this.activeFilters[i]
      let column
      if (filter.field) {
        column = this.columnDefinitions[filter.field]
        if (column && !column.filter(device, filter)) {
          return false
        }
      }
      else {
        let found = false
        for (let j = 0, k = this.activeColumns.length; j < k; ++j) {
          column = this.columnDefinitions[this.activeColumns[j]]
          if (column && column.filter(device, filter)) {
            found = true
            break
          }
        }
        if (!found) {
          return false
        }
      }
    }
    return true
  }

  // Inserts an item into the table into its correct position according to
  // current sorting.
  insertItem(item, deviceA) {
    return this.insertItemToSegment(item, deviceA, 0, this.items.length - 1)
  }

  // Inserts an item into a segment of the table into its correct position
  // according to current sorting. The value of `hi` is the index
  // of the last item in the segment, or -1 if none. The value of `lo`
  // is the index of the first item in the segment, or 0 if none.
  insertItemToSegment(item, deviceA, low, high) {
    let total = this.items.length
    let lo = low
    let hi = high

    if (lo > hi) {
      // This means that `lo` refers to the first item of the next
      // segment (which may or may not exist), and we should put the
      // row before it.
      this.list.insertBefore(item, lo < total ? this.items[lo] : null)
    }
    else {
      let after = true
      let pivot = 0
      let deviceB

      while (lo <= hi) {
        pivot = ~~((lo + hi) / 2)
        deviceB = this.mapping[this.items[pivot].id];

        let diff = this.compare(deviceA, deviceB)

        if (diff === 0) {
          after = true
          break
        }

        if (diff < 0) {
          hi = pivot - 1
          after = false
        }
        else {
          lo = pivot + 1
          after = true
        }
      }

      if (after) {
        this.list.insertBefore(item, this.items[pivot].nextSibling)
      }
      else {
        this.list.insertBefore(item, this.items[pivot])
      }
    }
  }

  patchArray(a, b) {
    let ops = []

    let workA = [].concat(a)
    let inA = Object.create(null)
    let itemA, cursorA, itemB, cursorB

    let inB = this.existenceMap(b)
    let posB = Object.create(null)

    // First, check what was removed from a.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]

      // If b does not contain the item, surely it must have been removed.
      if (!inB[itemA]) {
        workA.splice(cursorA, 1)
        ops.push(['remove', cursorA])
      }
      // Otherwise, the item is still alive.
      else {
        inA[itemA] = true
        cursorA += 1
      }
    }

    // Then, check what was inserted into b.
    for (cursorB = 0; cursorB < b.length; ++cursorB) {
      itemB = b[cursorB]

      // If a does not contain the item, it must have been added.
      if (!inA[itemB]) {
        workA.splice(cursorB, 0, itemB)
        ops.push(['insert', cursorB, itemB])
      }

      posB[itemB] = cursorB
    }

    // At this point, workA contains the same items as b, but swaps may
    // be needed.
    for (cursorA = 0; cursorA < workA.length;) {
      itemA = workA[cursorA]
      let posInB = posB[itemA]

      if (posInB === cursorA) {
        cursorA += 1
      }
      else {
        let temp = workA[posInB]
        workA[posInB] = itemA
        workA[cursorA] = temp
        ops.push(['swap', cursorA, posInB])
      }
    }
    return ops
  }

  // Patches all items.
  patchAll(patch) {
    for (let i = 0, l = this.items.length; i < l; ++i) {
      this.patchItem(this.items[i], this.mapping[this.items[i].id], patch)
    }
  }

  // Patches the given item by running the given patch operations in
  // order. The operations must take into account index changes caused
  // by previous operations.
  patchItem(item, device, patch) {
    // Currently no-op
  }

  existenceMap(array) {
    let map = Object.create(null)
    for (let i = 0, l = array.length; i < l; ++i) {
      map[array[i]] = 1
    }
    return map
  }

  openScreenRecord() {
    this.screenRecord = !this.screenRecord;
  }

  cross() {
    this.screenRecord = !this.screenRecord;
  }

  aboutDeviceToggle() {
    this.aboutDevice = !this.aboutDevice
  }

  aboutDeviceToggle2() {
    this.aboutDevice1 = !this.aboutDevice1
  }

  masterSlaveExitfunc() {
    //for parent device
    this.ws?.close();
    this.kickDevice(this.device, true);
    this.input.removeEventListener('keydown', this.listeners['keydown']);
    this.input.removeEventListener('keyup', this.listeners['keyup']);
    this.input.removeEventListener('input', this.listeners['input']);
    this.input.removeEventListener('paste', this.listeners['paste']);
    this.input.removeEventListener('copy', this.listeners['copy']);
    //for device 1
    this.ws1?.close();
    this.kickDevice(this.device1, true);
    // this.input1.removeEventListener('keydown', this.listeners1['keydown']);
    // this.input1.removeEventListener('keyup', this.listeners1['keyup']);
    // this.input1.removeEventListener('input', this.listeners1['input']);
    // this.input1.removeEventListener('paste', this.listeners1['paste']);
    // this.input1.removeEventListener('copy', this.listeners1['copy']);
    //for device 2
    if (this.deviceCount >= 3) {
      this.ws2?.close();
      this.kickDevice(this.device2, true);
    }
    // this.input2.removeEventListener('keydown', this.listeners2['keydown']);
    // this.input2.removeEventListener('keyup', this.listeners2['keyup']);
    // this.input2.removeEventListener('input', this.listeners2['input']);
    // this.input2.removeEventListener('paste', this.listeners2['paste']);
    // this.input2.removeEventListener('copy', this.listeners2['copy']);
    //for device 3
    if (this.deviceCount >= 4) {
      this.ws3?.close();
      this.kickDevice(this.device3, true);
    }
    // this.input3.removeEventListener('keydown', this.listeners3['keydown']);
    // this.input3.removeEventListener('keyup', this.listeners3['keyup']);
    // this.input3.removeEventListener('input', this.listeners3['input']);
    // this.input3.removeEventListener('paste', this.listeners3['paste']);
    // this.input3.removeEventListener('copy', this.listeners3['copy']);
    //for device 4
    if (this.deviceCount == 5) {
      this.ws4?.close();
      this.kickDevice(this.device4, true);
    }
    // this.input4.removeEventListener('keydown', this.listeners4['keydown']);
    // this.input4.removeEventListener('keyup', this.listeners4['keyup']);
    // this.input4.removeEventListener('input', this.listeners4['input']);
    // this.input4.removeEventListener('paste', this.listeners4['paste']);
    // this.input4.removeEventListener('copy', this.listeners4['copy']);
    // Emit the exit event
    this.commonService.setActiveTab('/devices');
    this.router.navigate(['/devices']);
  }

  key(key: any) {
    if (this.device.ios) {
      this.control.keyPress(key)
      //for slave devices
      this.control1.keyPress(key)
      this.control2.keyPress(key)
      this.control3.keyPress(key)
      this.control4.keyPress(key)
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
    //for slave devices
    this.control1.keyDown(key)
    this.control1.keyUp(key)
    this.control2.keyDown(key)
    this.control2.keyUp(key)
    this.control3.keyDown(key)
    this.control3.keyUp(key)
    this.control4.keyDown(key)
    this.control4.keyUp(key)
  }

  press(key) {
    this.control.keyPress(key)
    //for slave devices
    this.control1.keyPress(key)
    this.control2.keyPress(key)
    this.control3.keyPress(key)
    this.control4.keyPress(key)
  }

  openSettings() {
    if (this.device.ios)
      this.control.openSetting();
    else
      this.run('am start -a android.intent.action.MAIN -n com.android.settings/.Settings')
  }

  run(cmd) {
    let command = cmd;
    // Force run activity
    command += ' --activity-clear-top'
    // return this.control.shell(command).then(function(result) {
    //     // console.log(result)
    //   })
    return this.control.shell(command);
  }

  kickSecondDevice() {
    this.kickDevice(this.device1, true);
    this.commonService.setActiveTab('/control/');
    this.router.navigate(['/control', this.device.serial]);
  }

  getTopPosition(device: any): string {
    return device?.platform == 'iOS' ? '-3vh' : '-7vh';
  }

  toggleThrottleOptions(): void {
    setTimeout(() => {
      this.showThrottleOptions = !this.showThrottleOptions;
    }, 0);
  }

  applyThrottle(option: { label: string, value: number }): void {
    if (!this.device && !this.device.ios) {
      this.msg = 'No device information available';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    const androidVersion = parseFloat(this.device.version || '0');

    if (!androidVersion || androidVersion < 13) {
      this.msg = 'Throttling is not supported on this device. Android 13 or higher is required.';
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    let command = `settings put global ingress_rate_limit_bytes_per_second ${option.value}`;
    this.control.shell(command);
    this.msg = `Throttle set to ${option.label}`;
    this.openAlertMod(this.alertTemplate, this.msg);
    this.toggleThrottleOptions();
    this.toggleStates['throttle'] = false;
  }

  appInstall() {
    this.modalRef = this.dialog.open(this.appInstallTemplate, { width: '300px' });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0] as File;
    this.installFile(file, this.device.serial);
  }

  installFile(file, deviceSerial: any) {


    if (file.type === 'application/vnd.android.package-archive') {
      // Process the file upload

      // this.uploadApk =false;
      this.appInstalling = true
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 10;
        } else {
          clearInterval(interval); // Stop when it reaches 100%  
        }
      }, 900);
      return this.installService.installFile(this.control, file, deviceSerial)

    } else {
      this.msg = "Please select a valid APK file.";
      this.openAlertMod(this.alertTemplate, this.msg);
      // alert('Please select a valid APK file.');
      return null;
    }


    // }
  }

  takeScreenShot() {

    // let blob = new Blob([], {
    //   type: 'image/jpeg'
    // })
    // let url = URL.createObjectURL(blob)
    // // img.src
    // let mySrc = this.sanitizer.bypassSecurityTrustUrl(url);
    // this.source=url
    if (this.device.ios) {
      this.control.screenshotIos().then((result) => {


        this.control.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    else {
      this.control.screenshot().then((result) => {


        this.control.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    this.openAlertMod(this.alertTemplate, 'Screenshot taken! You can view the screenshots in the Screenshot tab');
  }

  takeScreenShot2() {

    // let blob = new Blob([], {
    //   type: 'image/jpeg'
    // })
    // let url = URL.createObjectURL(blob)
    // // img.src
    // let mySrc = this.sanitizer.bypassSecurityTrustUrl(url);
    // this.source=url
    if (this.device1.ios) {
      this.control1.screenshotIos().then((result) => {


        this.control1.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    else {
      this.control1.screenshot().then((result) => {


        this.control1.screenshots.unshift(result);


        this.storageService.saveScreenShot(result, this.email);
        setTimeout(() => {
          this.resizeImageOfIos({ max: 100, step: 1 })
        }, 0)
      })
    }
    this.openAlertMod(this.alertTemplate, 'Screenshot taken! You can view the screenshots in the Screenshot tab');
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  Ok() {
    this.modalRef.close();;
  }

  resizeImageOfIos(param) {
    if (this.value < param.min) {
      this.value = param.min;
    } else if (this.value > param.max) {
      this.value = param.max;
    }

    let cols = document.getElementsByClassName('screenshot-image resizeIOS') as HTMLCollectionOf<HTMLImageElement>;
    for (let i = 0; i < cols.length; i++) {
      let sampleWidth = 550 * ((this.value / 100) * param.step);
      let sampleHeight = 1000 * ((this.value / 100) * param.step);
      cols[i].style.width = (225 + sampleWidth) + 'px';
      cols[i].style.height = (400 + sampleHeight) + 'px';
    }
  }

  methodOne() {
    let _global = this;

    // ios change
    if (this.device.ios) {
      this.ws = new WebSocket(this.device.url);
    }
    else {
      this.ws = new WebSocket(this.device.display.url);
    }
    // ios change
    this.ws.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    let canvas = this.element.querySelector('canvas');
    // let canvas = this.element.find('canvas')[0]
    //let mobile_wrapper=element.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element.querySelector('div');

    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws = null;
    }

    this.ws.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element is an object HTMLUnknownElement in IE9
      let w = _global.screen.bounds.w = (_global.element.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen.bounds.h = (_global.element.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device anymore.
        _global.device.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('off')
      }
    }

    this.ws.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen.bounds.w ||
          cachedScreen.bounds.h !== _global.screen.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen.rotation
      }

      function isRotated() {
        return _global.screen.rotation === 90 || _global.screen.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen.rotation);

        canvas.style[_global.cssTransform] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen.bounds.h;
        cachedScreen.bounds.w = _global.screen.bounds.w;
        cachedScreen.rotation = _global.screen.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated = true;
          canvasAspect = img.height / img.width;
          _global.element.classList.add('rotated');
          _global.element.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated = false;
          canvasAspect = img.width / img.height
          _global.element.classList.remove('rotated')
          _global.element.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen.rotation = _global.device.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader = false;
        //   _global.cursor = 'default';
        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError) {
        //       // scope.$apply(function() {
        //       //   this.displayError = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        //for decompression in FE
        if (message.data instanceof Blob) {
          _global.loader = false;
          _global.cursor = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element.offsetWidth / _global.element.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element;

    //   if (this.isScreenRotated) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  //for device1
  methodOneDevice1() {
    let _global = this;

    // ios change
    if (this.device1.ios) {
      this.ws1 = new WebSocket(this.device1.url);
    }
    else {
      this.ws1 = new WebSocket(this.device1.display.url);
    }
    // ios change
    this.ws1.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    if (this.deviceCount != 5) this.element1 = this.elementRef.nativeElement.firstElementChild.children[2].children[0];
    else this.element1 = this.elementRef.nativeElement.firstElementChild.children[3].children[0].children[0]; // device1
    this.displayError1 = false;
    this.input1 = this.element1.querySelector('input');
    let canvas = this.element1.querySelector('canvas');
    this.scaler1 = this.scalingService.coordinator(
      this.device1.display.width
      , this.device1.display.height
    );

    // let canvas = this.element1.find('canvas')[0]
    //let mobile_wrapper=element1.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element1.querySelector('div');

    this.deviceService.updateOwnerInfo(this.device1.serial, this.device1.owner).pipe(first()).subscribe();


    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws1.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws1.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws1 = null;
    }

    this.ws1.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device1.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device1.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element1 is an object HTMLUnknownElement in IE9
      let w = _global.screen1.bounds.w = (_global.element1.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen1.bounds.h = (_global.element1.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen1.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen1.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device1 anymore.
        _global.device1.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws1.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws1.readyState === WebSocket.OPEN) {
        _global.ws1.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws1.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws1.readyState === WebSocket.OPEN) {
        _global.ws1.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws1.readyState === WebSocket.OPEN) {
        _global.ws1.send('off')
      }
    }

    this.ws1.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element1.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen1.bounds.w ||
          cachedScreen.bounds.h !== _global.screen1.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen1.rotation
      }

      function isRotated() {
        return _global.screen1.rotation === 90 || _global.screen1.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen1.rotation);

        canvas.style[_global.cssTransform1] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen1.bounds.h;
        cachedScreen.bounds.w = _global.screen1.bounds.w;
        cachedScreen.rotation = _global.screen1.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect1 = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform1] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated = true;
          canvasAspect = img.height / img.width;
          _global.element1.classList.add('rotated');
          _global.element1.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated = false;
          canvasAspect = img.width / img.height
          _global.element1.classList.remove('rotated')
          _global.element1.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen1 image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform1] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen1.rotation = _global.device1.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader1 = false;
        //   _global.cursor1 = 'default';
        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError1) {
        //       // scope.$apply(function() {
        //       //   this.displayError1 = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG1;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG1
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        if (message.data instanceof Blob) {
          _global.loader1 = false;
          _global.cursor1 = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError1 = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device1.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element1.offsetWidth / _global.element1.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element1.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element1.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element1;

    //   if (this.isScreenRotated) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  //for device2
  methodOneDevice2() {
    let _global = this;

    // ios change
    if (this.device2.ios) {
      this.ws2 = new WebSocket(this.device2.url);
    }
    else {
      this.ws2 = new WebSocket(this.device2.display.url);
    }
    // ios change
    this.ws2.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    if (this.deviceCount != 5) this.element2 = this.elementRef.nativeElement.firstElementChild.children[2].children[1];
    else this.element2 = this.elementRef.nativeElement.firstElementChild.children[3].children[0].children[1]; // device2
    this.displayError2 = false;
    this.input2 = this.element2.querySelector('input');
    let canvas = this.element2.querySelector('canvas');
    this.scaler2 = this.scalingService.coordinator(
      this.device2.display.width
      , this.device2.display.height
    );

    // let canvas = this.element2.find('canvas')[0]
    //let mobile_wrapper=element2.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element2.querySelector('div');

    this.deviceService.updateOwnerInfo(this.device2.serial, this.device2.owner).pipe(first()).subscribe();


    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws2.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws2.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws2 = null;
    }

    this.ws2.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device2.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device2.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element2 is an object HTMLUnknownElement in IE9
      let w = _global.screen2.bounds.w = (_global.element2.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen2.bounds.h = (_global.element2.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen2.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen2.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device2 anymore.
        _global.device2.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws2.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws2.readyState === WebSocket.OPEN) {
        _global.ws2.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws2.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws2.readyState === WebSocket.OPEN) {
        _global.ws2.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws2.readyState === WebSocket.OPEN) {
        _global.ws2.send('off')
      }
    }

    this.ws2.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element2.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen2.bounds.w ||
          cachedScreen.bounds.h !== _global.screen2.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen2.rotation
      }

      function isRotated() {
        return _global.screen2.rotation === 90 || _global.screen2.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen2.rotation);

        canvas.style[_global.cssTransform2] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen2.bounds.h;
        cachedScreen.bounds.w = _global.screen2.bounds.w;
        cachedScreen.rotation = _global.screen2.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect1 = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform2] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated2 = true;
          canvasAspect = img.height / img.width;
          _global.element2.classList.add('rotated');
          _global.element2.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated2 = false;
          canvasAspect = img.width / img.height
          _global.element2.classList.remove('rotated')
          _global.element2.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen2 image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform2] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen2.rotation = _global.device2.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader2 = false;
        //   _global.cursor2 = 'default';
        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError2) {
        //       // scope.$apply(function() {
        //       //   this.displayError2 = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG2;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG2
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        if (message.data instanceof Blob) {
          _global.loader2 = false;
          _global.cursor2 = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError2 = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device2.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element2.offsetWidth / _global.element2.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element2.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element2.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element2;

    //   if (this.isScreenRotated2) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  //for device3
  methodOneDevice3() {
    let _global = this;

    // ios change
    if (this.device3.ios) {
      this.ws3 = new WebSocket(this.device3.url);
    }
    else {
      this.ws3 = new WebSocket(this.device3.display.url);
    }
    // ios change
    this.ws3.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    if (this.deviceCount != 5) this.element3 = this.elementRef.nativeElement.firstElementChild.children[2].children[2];
    else this.element3 = this.elementRef.nativeElement.firstElementChild.children[3].children[1].children[0]; // device3
    this.displayError3 = false;
    this.input3 = this.element3.querySelector('input');
    let canvas = this.element3.querySelector('canvas');
    this.scaler3 = this.scalingService.coordinator(
      this.device3.display.width
      , this.device3.display.height
    );

    // let canvas = this.element3.find('canvas')[0]
    //let mobile_wrapper=element3.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element3.querySelector('div');

    this.deviceService.updateOwnerInfo(this.device3.serial, this.device3.owner).pipe(first()).subscribe();


    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws3.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws3.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws3 = null;
    }

    this.ws3.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device3.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device3.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element3 is an object HTMLUnknownElement in IE9
      let w = _global.screen3.bounds.w = (_global.element3.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen3.bounds.h = (_global.element3.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen3.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen3.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device3 anymore.
        _global.device3.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws3.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws3.readyState === WebSocket.OPEN) {
        _global.ws3.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws3.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws3.readyState === WebSocket.OPEN) {
        _global.ws3.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws3.readyState === WebSocket.OPEN) {
        _global.ws3.send('off')
      }
    }

    this.ws3.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element3.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen3.bounds.w ||
          cachedScreen.bounds.h !== _global.screen3.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen3.rotation
      }

      function isRotated() {
        return _global.screen3.rotation === 90 || _global.screen3.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen3.rotation);

        canvas.style[_global.cssTransform3] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen3.bounds.h;
        cachedScreen.bounds.w = _global.screen3.bounds.w;
        cachedScreen.rotation = _global.screen3.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect3 = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform3] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated3 = true;
          canvasAspect = img.height / img.width;
          _global.element3.classList.add('rotated');
          _global.element3.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated3 = false;
          canvasAspect = img.width / img.height
          _global.element3.classList.remove('rotated')
          _global.element3.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen3 image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform3] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen3.rotation = _global.device3.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader3 = false;
        //   _global.cursor3 = 'default';
        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError3) {
        //       // scope.$apply(function() {
        //       //   this.displayError3 = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG3;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG3
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        if (message.data instanceof Blob) {
          _global.loader3 = false;
          _global.cursor3 = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError3 = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device3.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element3.offsetWidth / _global.element3.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element3.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element3.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element3;

    //   if (this.isScreenRotated3) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  //for device4
  methodOneDevice4() {
    let _global = this;

    // ios change
    if (this.device4.ios) {
      this.ws4 = new WebSocket(this.device4.url);
    }
    else {
      this.ws4 = new WebSocket(this.device4.display.url);
    }
    // ios change
    this.ws4.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    this.element4 = this.elementRef.nativeElement.firstElementChild.children[3].children[1].children[1]; // device4
    this.displayError4 = false;
    this.input4 = this.element4.querySelector('input');
    let canvas = this.element4.querySelector('canvas');
    this.scaler4 = this.scalingService.coordinator(
      this.device4.display.width
      , this.device4.display.height
    );

    // let canvas = this.element4.find('canvas')[0]
    //let mobile_wrapper=element4.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element4.querySelector('div');

    this.deviceService.updateOwnerInfo(this.device4.serial, this.device4.owner).pipe(first()).subscribe();


    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }


    this.ws4.onerror = function errorListener() {
      // @todo Handle
    }

    this.ws4.onclose = function closeListener() {
      // @todo Maybe handle
      _global.ws4 = null;
    }

    this.ws4.onopen = function openListener() {
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device4.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device4.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      // FIXME: element4 is an object HTMLUnknownElement in IE9
      let w = _global.screen4.bounds.w = (_global.element4.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen4.bounds.h = (_global.element4.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen4.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen4.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device4 anymore.
        _global.device4.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws4.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws4.readyState === WebSocket.OPEN) {
        _global.ws4.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws4.send('on')
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws4.readyState === WebSocket.OPEN) {
        _global.ws4.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws4.readyState === WebSocket.OPEN) {
        _global.ws4.send('off')
      }
    }

    this.ws4.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element4.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen4.bounds.w ||
          cachedScreen.bounds.h !== _global.screen4.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen4.rotation
      }

      function isRotated() {
        return _global.screen4.rotation === 90 || _global.screen4.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen4.rotation);

        canvas.style[_global.cssTransform4] = 'rotate(' + cssRotation + 'deg)'

        cachedScreen.bounds.h = _global.screen4.bounds.h;
        cachedScreen.bounds.w = _global.screen4.bounds.w;
        cachedScreen.rotation = _global.screen4.rotation;

        let canvasAspect = canvas.width / canvas.height;
        let incwidth = canvas.width * 1.035; //increase the width of the wrapper by 3.5%
        let incheight = canvas.height * 1.025; //increase the height of the wrapper by 2.5%
        _global.canvasAspect4 = incwidth / incheight;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform4] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        if (isRotated()) {
          _global.isScreenRotated4 = true;
          canvasAspect = img.height / img.width;
          _global.element4.classList.add('rotated');
          _global.element4.parentElement.firstElementChild.classList.add('rotatedImg');
        }
        else {
          _global.isScreenRotated4 = false;
          canvasAspect = img.width / img.height
          _global.element4.classList.remove('rotated')
          _global.element4.parentElement.firstElementChild.classList.remove('rotatedImg')
        }

        if (alwaysUpright) {
          // If the screen4 image is always in upright position (but we
          // still want the rotation animation), we need to cancel out
          // the rotation by using another rotation.
          positioner.style[_global.cssTransform4] = 'rotate(' + -cssRotation + 'deg)'
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen4.rotation = _global.device4.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader4 = false;
        //   _global.cursor4 = 'default';
        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError4) {
        //       // scope.$apply(function() {
        //       //   this.displayError4 = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG4;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG4
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        if (message.data instanceof Blob) {
          _global.loader4 = false;
          _global.cursor4 = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError4 = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device4.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element4.offsetWidth / _global.element4.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element4.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element4.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element4;

    //   if (this.isScreenRotated4) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  rotator(oldRotation: any, newRotation: any) {
    let r1 = oldRotation < 0 ? 360 + oldRotation % 360 : oldRotation % 360
    let r2 = newRotation < 0 ? 360 + newRotation % 360 : newRotation % 360

    return this.mapping[r1][r2];
  }

  // touchHandlingMethod() {

  //   //ios change
  //   //let prevCoords = {}
  //   //ios change
  //   let slots = [];
  //   let slotted = Object.create(null);
  //   let fingers = [];
  //   let seq = -1;
  //   let cycle = 100;
  //   let fakePinch = false;
  //   let lastPossiblyBuggyMouseUpEvent: any = 0;

  //   let nextSeq = () => {
  //     return ++seq >= cycle ? (seq = 0) : seq
  //   }

  //   let createSlots = () => {
  //     // The reverse order is important because slots and fingers are in
  //     // opposite sort order. Anyway don't change anything here unless
  //     // you understand what it does and why.
  //     for (let i = 9; i >= 0; --i) {
  //       let finger = createFinger(i);
  //       this.element.append(finger);
  //       slots.push(i);
  //       fingers.unshift(finger);
  //     }
  //   }

  //   let activateFinger = (index: any, x: any, y: any, pressure: any) => {
  //     let scale = 0.5 + pressure
  //     fingers[index].classList.add('active')
  //     fingers[index].style[this.cssTransform1] =
  //       'translate3d(' + x + 'px,' + y + 'px,0) ' +
  //       'scale(' + scale + ',' + scale + ')'
  //   }

  //   let deactivateFinger = (index: any) => {
  //     fingers[index].classList.remove('active')
  //   }

  //   let deactivateFingers = () => {
  //     for (let i = 0, l = fingers.length; i < l; ++i) {
  //       fingers[i].classList.remove('active')
  //     }
  //   }

  //   let createFinger = (index: any) => {
  //     let el = document.createElement('span')
  //     el.className = 'finger finger-' + index
  //     return el;
  //   }

  //   let calculateBounds = () => {

  //     let el = this.element as HTMLElement;

  //     this.screen.bounds.w = el.offsetWidth
  //     this.screen.bounds.h = el.offsetHeight
  //     this.screen.bounds.x = 0
  //     this.screen.bounds.y = 0

  //     while (el.offsetParent) {
  //       this.screen.bounds.x += el.offsetLeft
  //       this.screen.bounds.y += el.offsetTop
  //       el = el.offsetParent as HTMLElement;
  //     }
  //   }

  //   let mouseDownListener = (event: any) => {

  //     let e = event;
  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     // Skip secondary click
  //     if (e.which === 3) {
  //       return
  //     }

  //     e.preventDefault()

  //     fakePinch = e.altKey

  //     calculateBounds()
  //     startMousing()

  //     let x = e.pageX - this.screen.bounds.x;
  //     let y = e.pageY - this.screen.bounds.y;
  //     let pressure = 0.5
  //     let scaled = this.scaler.coords(
  //       this.screen.bounds.w
  //       , this.screen.bounds.h
  //       , x
  //       , y
  //       , this.screen.rotation
  //     )
  //     //ios change
  //     this.prevCoords = {
  //       x: scaled.xP,
  //       y: scaled.yP,
  //     }
  //     //ios change

  //     // ios change
  //     if (this.device.ios === true) {
  //       this.control.touchDownIos(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
  //       if (fakePinch) {
  //         this.control.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //       }
  //     } else {
  //       const seq = nextSeq();
  //       this.control.touchDown(seq, 0, scaled.xP, scaled.yP, pressure)
  //       this.applyTouchToSlaves('down', seq, 0, scaled.xP, scaled.yP, pressure);
  //       if (fakePinch) {
  //         const seq = nextSeq();
  //         this.control.touchDown(seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //         this.applyTouchToSlaves('down', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
  //       }
  //     }
  //     // ios change

  //     // this.control.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure);

  //     // if (fakePinch) {
  //     //   this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP,
  //     //     pressure)
  //     // }

  //     this.control.touchCommit(nextSeq())

  //     activateFinger(0, x, y, pressure)

  //     if (fakePinch) {
  //       activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
  //         -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
  //     }

  //     this.element.addEventListener('mousemove', mouseMoveListener);
  //     this.element.addEventListener('mouseup', mouseUpListener);
  //     this.element.addEventListener('mouseleave', mouseUpListener);

  //     // this.renderer.listen(this.element, 'mousemove', mouseMoveListener);
  //     // this.renderer.listen(this.element, 'mouseup', mouseUpListener);
  //     // this.renderer.listen(this.element, 'mouseleave', mouseUpListener);
  //     // this.element.bind('mousemove', mouseMoveListener)
  //     // $document.bind('mouseup', mouseUpListener)
  //     // $document.bind('mouseleave', mouseUpListener)

  //     if (lastPossiblyBuggyMouseUpEvent &&
  //       lastPossiblyBuggyMouseUpEvent.timeStamp > e.timeStamp) {
  //       // We got mouseup before mousedown. See mouseUpBugWorkaroundListener
  //       // for details.
  //       mouseUpListener(lastPossiblyBuggyMouseUpEvent)
  //     }
  //     else {
  //       lastPossiblyBuggyMouseUpEvent = null
  //     }
  //   }

  //   let mouseMoveListener = (event: any) => {

  //     let e = event
  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     // Skip secondary click
  //     if (e.which === 3) {
  //       return
  //     }
  //     e.preventDefault()

  //     let addGhostFinger = !fakePinch && e.altKey
  //     let deleteGhostFinger = fakePinch && !e.altKey

  //     fakePinch = e.altKey

  //     let x = e.pageX - this.screen.bounds.x
  //     let y = e.pageY - this.screen.bounds.y
  //     let pressure = 0.5
  //     let scaled = this.scaler.coords(
  //       this.screen.bounds.w
  //       , this.screen.bounds.h
  //       , x
  //       , y
  //       , this.screen.rotation
  //     )

  //     const seq = nextSeq();
  //     this.control.touchMove(seq, 0, scaled.xP, scaled.yP, pressure)
  //     this.applyTouchToSlaves('move', seq, 0, scaled.xP, scaled.yP, pressure);

  //     if (addGhostFinger) {
  //       //ios change
  //       if (this.device.ios === true) {
  //         this.control.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //       } else {
  //         const seq = nextSeq();
  //         this.control.touchDown(seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //         this.applyTouchToSlaves('down', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
  //       }
  //       //ios change
  //       // this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //     }
  //     else if (deleteGhostFinger) {
  //       const seq = nextSeq();
  //       this.control.touchUp(seq, 1)
  //       this.applyTouchToSlaves('up', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
  //     }
  //     else if (fakePinch) {
  //       const seq = nextSeq();
  //       this.control.touchMove(seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
  //       this.applyTouchToSlaves('move', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
  //     }

  //     this.control.touchCommit(nextSeq())

  //     activateFinger(0, x, y, pressure)

  //     if (deleteGhostFinger) {
  //       deactivateFinger(1)
  //     }
  //     else if (fakePinch) {
  //       activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
  //         -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
  //     }
  //   }

  //   let mouseUpListener = (event: any) => {


  //     let e = event;
  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     // Skip secondary click
  //     if (e.which === 3) {
  //       return
  //     }
  //     e.preventDefault()

  //     //ios change
  //     const x = e.pageX - this.screen.bounds.x
  //     const y = e.pageY - this.screen.bounds.y
  //     const pressure = 0.5
  //     const scaled = this.scaler.coords(
  //       this.screen.bounds.w,
  //       this.screen.bounds.h,
  //       x,
  //       y,
  //       this.screen.rotation,
  //       this.device.ios,
  //     )
  //     // (Math.abs(prevCoords.x - scaled.xP) >= 0.1|| Math.abs(prevCoords.y - scaled.yP) >= 0.1)
  //     if (this.device.ios && this.device.ios === true) { // TODO: can be non boolean?
  //       this.control.touchMoveIos(
  //         scaled.xP,
  //         scaled.yP,
  //         this.prevCoords.x,
  //         this.prevCoords.y,
  //         pressure,
  //         nextSeq(),
  //         0
  //       )
  //     }
  //     //ios change
  //     const seq = nextSeq();
  //     this.control.touchUp(seq, 0)
  //     this.applyTouchToSlaves('up', seq, 0, scaled.xP, scaled.yP, pressure);

  //     if (fakePinch) {
  //       const seq = nextSeq();
  //       this.control.touchUp(seq, 1)
  //       this.applyTouchToSlaves('up', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
  //     }

  //     this.control.touchCommit(nextSeq())

  //     deactivateFinger(0)

  //     if (fakePinch) {
  //       deactivateFinger(1)
  //     }

  //     stopMousing()
  //   }

  //   /**
  //    * Do NOT remove under any circumstances. Currently, in the latest
  //    * Safari (Version 8.0 (10600.1.25)), if an input field is focused
  //    * while we do a tap click on an MBP trackpad ("Tap to click" in
  //    * Settings), it sometimes causes the mouseup event to trigger before
  //    * the mousedown event (but event.timeStamp will be correct). It
  //    * doesn't happen in any other browser. The following minimal test
  //    * case triggers the same behavior (although less frequently). Keep
  //    * tapping and you'll eventually see see two mouseups in a row with
  //    * the same counter value followed by a mousedown with a new counter
  //    * value. Also, when the bug happens, the cursor in the input field
  //    * stops blinking. It may take up to 300 attempts to spot the bug on
  //    * a MacBook Pro (Retina, 15-inch, Mid 2014).
  //    *
  //    *     <!doctype html>
  //    *
  //    *     <div id="touchable"
  //    *       style="width: 100px; height: 100px; background: green"></div>
  //    *     <input id="focusable" type="text" />
  //    *
  //    *     <script>
  //    *     let touchable = document.getElementById('touchable')
  //    *       , focusable = document.getElementById('focusable')
  //    *       , counter = 0
  //    *
  //    *     function mousedownListener(e) {
  //    *       counter += 1
  //    *       console.log('mousedown', counter, e, e.timeStamp)
  //    *       e.preventDefault()
  //    *     }
  //    *
  //    *     function mouseupListener(e) {
  //    *       e.preventDefault()
  //    *       console.log('mouseup', counter, e, e.timeStamp)
  //    *       focusable.focus()
  //    *     }
  //    *
  //    *     touchable.addEventListener('mousedown', mousedownListener, false)
  //    *     touchable.addEventListener('mouseup', mouseupListener, false)
  //    *     </script>
  //    *
  //    * I believe that the bug is caused by some kind of a race condition
  //    * in Safari. Using a textarea or a focused contenteditable does not
  //    * get rid of the bug. The bug also happens if the text field is
  //    * focused manually by the user (not with .focus()).
  //    *
  //    * It also doesn't help if you .blur() before .focus().
  //    *
  //    * So basically we'll just have to store the event on mouseup and check
  //    * if we should do the browser's job in the mousedown handler.
  //    */

  //   let mouseUpBugWorkaroundListener = (e: any) => {
  //     lastPossiblyBuggyMouseUpEvent = e
  //   }

  //   let startMousing = () => {
  //     this.control.gestureStart(nextSeq())
  //     this.input.focus()
  //   }

  //   let stopMousing = () => {
  //     this.element.removeEventListener('mousemove', mouseMoveListener);
  //     this.element.removeEventListener('mouseup', mouseUpListener);
  //     this.element.removeEventListener('mouseleave', mouseUpListener);
  //     // this.element.unbind('mousemove', mouseMoveListener)
  //     // $document.unbind('mouseup', mouseUpListener)
  //     // $document.unbind('mouseleave', mouseUpListener)
  //     deactivateFingers()
  //     this.control.gestureStop(nextSeq())
  //   }

  //   let touchStartListener = (event: any) => {
  //     let e = event;
  //     e.preventDefault()

  //     //Make it jQuery compatible also
  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     calculateBounds()

  //     if (e.touches.length === e.changedTouches.length) {
  //       startTouching()
  //     }

  //     let currentTouches = Object.create(null)
  //     let i, l

  //     for (i = 0, l = e.touches.length; i < l; ++i) {
  //       currentTouches[e.touches[i].identifier] = 1
  //     }

  //     let maybeLostTouchEnd = (id: any) => {
  //       return !(id in currentTouches)
  //     }

  //     // We might have lost a touchend event due to various edge cases
  //     // (literally) such as dragging from the bottom of the screen so that
  //     // the control center appears. If so, let's ask for a reset.
  //     if (Object.keys(slotted).some(maybeLostTouchEnd)) {
  //       Object.keys(slotted).forEach((id) => {
  //         slots.push(slotted[id])
  //         delete slotted[id]
  //       })
  //       slots.sort().reverse()
  //       this.control.touchReset(nextSeq())
  //       deactivateFingers()
  //     }

  //     if (!slots.length) {
  //       // This should never happen but who knows...
  //       throw new Error('Ran out of multitouch slots')
  //     }

  //     for (i = 0, l = e.changedTouches.length; i < l; ++i) {
  //       let touch = e.changedTouches[i]
  //       let slot = slots.pop()
  //       let x = touch.pageX - this.screen.bounds.x
  //       let y = touch.pageY - this.screen.bounds.y
  //       let pressure = touch.force || 0.5
  //       let scaled = this.scaler.coords(
  //         this.screen.bounds.w
  //         , this.screen.bounds.h
  //         , x
  //         , y
  //         , this.screen.rotation
  //       )


  //       slotted[touch.identifier] = slot
  //       // ios change
  //       if (this.device.ios === true) { // TODO: can be non boolean?
  //         this.control.touchDownIos(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
  //       } else {
  //         const seq = nextSeq();
  //         this.control.touchDown(seq, slot, scaled.xP, scaled.yP, pressure)
  //         this.applyTouchToSlaves('down', seq, slot, scaled.xP, scaled.yP, pressure);
  //       }
  //       // ios change
  //       // this.control.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
  //       activateFinger(slot, x, y, pressure)
  //     }

  //     this.renderer.listen(this.element, 'touchmove', touchMoveListener);
  //     this.renderer.listen(this.element, 'touchend', touchEndListener);
  //     this.renderer.listen(this.element, 'touchleave', touchEndListener);
  //     // this.element.bind('touchmove', touchMoveListener)
  //     // $document.bind('touchend', touchEndListener)
  //     // $document.bind('touchleave', touchEndListener)

  //     this.control.touchCommit(nextSeq())
  //   }

  //   function touchMoveListener(event) {

  //     let e = event
  //     e.preventDefault()

  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
  //       let touch = e.changedTouches[i]
  //       let slot = slotted[touch.identifier]
  //       let x = touch.pageX - this.screen.bounds.x
  //       let y = touch.pageY - this.screen.bounds.y
  //       let pressure = touch.force || 0.5
  //       let scaled = this.scaler.coords(
  //         this.screen.bounds.w
  //         , this.screen.bounds.h
  //         , x
  //         , y
  //         , this.screen.rotation
  //       )
  //       const seq = nextSeq();
  //       this.control.touchMove(seq, slot, scaled.xP, scaled.yP, pressure)
  //       this.applyTouchToSlaves('move', seq, slot, scaled.xP, scaled.yP, pressure);
  //       activateFinger(slot, x, y, pressure)
  //     }

  //     this.control.touchCommit(nextSeq())
  //   }

  //   let touchEndListener = (event: any) => {
  //     let e = event;
  //     if (e.originalEvent) {
  //       e = e.originalEvent
  //     }

  //     let foundAny = false

  //     for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
  //       let touch = e.changedTouches[i]
  //       let slot = slotted[touch.identifier]
  //       if (typeof slot === 'undefined') {
  //         // We've already disposed of the contact. We may have gotten a
  //         // touchend event for the same contact twice.
  //         continue
  //       }
  //       delete slotted[touch.identifier]
  //       slots.push(slot)
  //       const seq = nextSeq();
  //       this.control.touchUp(seq, slot)
  //       this.applyTouchToSlaves('up', seq, slot, touch.pageX - this.screen.bounds.x, touch.pageY - this.screen.bounds.y, touch.force || 0.5);
  //       deactivateFinger(slot)
  //       foundAny = true
  //     }

  //     if (foundAny) {
  //       this.control.touchCommit(nextSeq())
  //       if (!e.touches.length) {
  //         stopTouching()
  //       }
  //     }
  //   }

  //   let startTouching = () => {
  //     this.control.gestureStart(nextSeq())
  //   }

  //   let stopTouching = () => {
  //     this.element.removeEventListener('touchmove', touchMoveListener);
  //     this.element.removeEventListener('touchend', touchEndListener);
  //     this.element.removeEventListener('touchleave', touchEndListener);
  //     // this.element.unbind('touchmove', touchMoveListener)
  //     // $document.unbind('touchend', touchEndListener)
  //     // $document.unbind('touchleave', touchEndListener)
  //     deactivateFingers()
  //     this.control.gestureStop(nextSeq())
  //   }

  //   this.renderer.listen(this.element, 'touchstart', touchStartListener);
  //   this.renderer.listen(this.element, 'mousedown', mouseDownListener);
  //   this.renderer.listen(this.element, 'mouseup', mouseUpBugWorkaroundListener);
  //   // this.element.on('touchstart', touchStartListener)
  //   // this.element.on('mousedown', mouseDownListener)
  //   // this.element.on('mouseup', mouseUpBugWorkaroundListener)

  //   createSlots()
  // }

  touchHandlingMethod() {
    // Original variables
    let slots = [];
    let slotted = Object.create(null);
    let fingers = [];
    let seq = -1;
    let cycle = 100;
    let fakePinch = false;
    let lastPossiblyBuggyMouseUpEvent: any = 0;

    // Slave device arrays for tracking
    let slaveSlots = [[], [], [], []]; // One for each slave device
    let slaveSlotted = [Object.create(null), Object.create(null), Object.create(null), Object.create(null)];
    let slaveFingers = [[], [], [], []];

    let nextSeq = () => {
      return ++seq >= cycle ? (seq = 0) : seq
    }

    // Helper function to propagate touch events to slave devices
    let propagateToSlaves = (action: string, seqNum: number, slot?: number, xP?: number, yP?: number, pressure?: number, prevX?: number, prevY?: number) => {
      const slaveControls = [this.control1, this.control2, this.control3, this.control4];
      const slaveScreens = [this.screen1, this.screen2, this.screen3, this.screen4];
      const slaveDevices = [this.device1, this.device2, this.device3, this.device4];

      slaveControls.forEach((control, index) => {
        if (!control) return; // Skip if slave control doesn't exist

        const screen = slaveScreens[index];
        const device = slaveDevices[index];

        let adjustedXP = xP;
        let adjustedYP = yP;
        let adjustedPrevX = prevX;
        let adjustedPrevY = prevY;

        // Apply aspect ratio conversion if coordinates are provided
        if (xP !== undefined && yP !== undefined && screen && screen.bounds) {
          // Convert from master coordinates to slave coordinates
          const masterAspectRatio = this.screen.bounds.w / this.screen.bounds.h;
          const slaveAspectRatio = screen.bounds.w / screen.bounds.h;

          // Adjust coordinates based on aspect ratio difference
          if (masterAspectRatio !== slaveAspectRatio) {
            // You might need to adjust this logic based on your specific scaling requirements
            adjustedXP = xP; // Keep same relative position
            adjustedYP = yP; // Keep same relative position
          }

          if (prevX !== undefined && prevY !== undefined) {
            adjustedPrevX = prevX;
            adjustedPrevY = prevY;
          }
        }

        // Execute the appropriate action on slave device
        switch (action) {
          case 'touchDown':
            if (device && device.ios === true) {
              control.touchDownIos(seqNum, slot, adjustedXP, adjustedYP, pressure);
            } else {
              control.touchDown(seqNum, slot, adjustedXP, adjustedYP, pressure);
            }
            break;
          case 'touchMove':
            control.touchMove(seqNum, slot, adjustedXP, adjustedYP, pressure);
            break;
          case 'touchMoveIos':
            if (device && device.ios === true) {
              control.touchMoveIos(adjustedXP, adjustedYP, adjustedPrevX, adjustedPrevY, pressure, seqNum, slot);
            }
            break;
          case 'touchUp':
            control.touchUp(seqNum, slot);
            break;
          case 'touchCommit':
            control.touchCommit(seqNum);
            break;
          case 'gestureStart':
            control.gestureStart(seqNum);
            break;
          case 'gestureStop':
            control.gestureStop(seqNum);
            break;
          case 'touchReset':
            control.touchReset(seqNum);
            break;
        }
      });
    }

    let createSlots = () => {
      // Create slots for master device
      for (let i = 9; i >= 0; --i) {
        let finger = createFinger(i);
        this.element.append(finger);
        slots.push(i);
        fingers.unshift(finger);
      }

      // Create slots for slave devices
      const slaveElements = [this.element1, this.element2, this.element3, this.element4];
      slaveElements.forEach((element, slaveIndex) => {
        if (!element) return;

        for (let i = 9; i >= 0; --i) {
          let finger = createFinger(i);
          element.append(finger);
          slaveSlots[slaveIndex].push(i);
          slaveFingers[slaveIndex].unshift(finger);
        }
      });
    }

    let activateFinger = (index: any, x: any, y: any, pressure: any) => {
      let scale = 0.5 + pressure
      fingers[index].classList.add('active')
      fingers[index].style[this.cssTransform1] =
        'translate3d(' + x + 'px,' + y + 'px,0) ' +
        'scale(' + scale + ',' + scale + ')'

      // Activate corresponding fingers on slave devices
      const slaveElements = [this.element1, this.element2, this.element3, this.element4];
      const slaveScreens = [this.screen1, this.screen2, this.screen3, this.screen4];
      const slaveDevices = [this.device1, this.device2, this.device3, this.device4];

      slaveElements.forEach((element, slaveIndex) => {
        if (!element || !slaveFingers[slaveIndex][index]) return;

        const screen = slaveScreens[slaveIndex];
        const device = slaveDevices[slaveIndex];

        // Convert coordinates for slave device if needed
        let slaveX = x;
        let slaveY = y;

        if (screen && screen.bounds) {
          // Scale coordinates based on slave device screen size
          slaveX = (x / this.screen.bounds.w) * screen.bounds.w;
          slaveY = (y / this.screen.bounds.h) * screen.bounds.h;
        }

        slaveFingers[slaveIndex][index].classList.add('active');
        const cssTransform = device && device.cssTransform1 ? device.cssTransform1 : this.cssTransform1;
        slaveFingers[slaveIndex][index].style[cssTransform] =
          'translate3d(' + slaveX + 'px,' + slaveY + 'px,0) ' +
          'scale(' + scale + ',' + scale + ')';
      });
    }

    let deactivateFinger = (index: any) => {
      fingers[index].classList.remove('active')

      // Deactivate corresponding fingers on slave devices
      const slaveElements = [this.element1, this.element2, this.element3, this.element4];
      slaveElements.forEach((element, slaveIndex) => {
        if (!element || !slaveFingers[slaveIndex][index]) return;
        slaveFingers[slaveIndex][index].classList.remove('active');
      });
    }

    let deactivateFingers = () => {
      for (let i = 0, l = fingers.length; i < l; ++i) {
        fingers[i].classList.remove('active')
      }

      // Deactivate all fingers on slave devices
      const slaveElements = [this.element1, this.element2, this.element3, this.element4];
      slaveElements.forEach((element, slaveIndex) => {
        if (!element) return;
        for (let i = 0, l = slaveFingers[slaveIndex].length; i < l; ++i) {
          slaveFingers[slaveIndex][i].classList.remove('active');
        }
      });
    }

    let createFinger = (index: any) => {
      let el = document.createElement('span')
      el.className = 'finger finger-' + index
      return el;
    }

    let calculateBounds = () => {
      let el = this.element as HTMLElement;

      this.screen.bounds.w = el.offsetWidth
      this.screen.bounds.h = el.offsetHeight
      this.screen.bounds.x = 0
      this.screen.bounds.y = 0

      while (el.offsetParent) {
        this.screen.bounds.x += el.offsetLeft
        this.screen.bounds.y += el.offsetTop
        el = el.offsetParent as HTMLElement;
      }

      // Calculate bounds for slave devices
      const slaveElements = [this.element1, this.element2, this.element3, this.element4];
      const slaveScreens = [this.screen1, this.screen2, this.screen3, this.screen4];

      slaveElements.forEach((element, index) => {
        if (!element || !slaveScreens[index]) return;

        const screen = slaveScreens[index];
        let slaveEl = element as HTMLElement;

        screen.bounds.w = slaveEl.offsetWidth;
        screen.bounds.h = slaveEl.offsetHeight;
        screen.bounds.x = 0;
        screen.bounds.y = 0;

        while (slaveEl.offsetParent) {
          screen.bounds.x += slaveEl.offsetLeft;
          screen.bounds.y += slaveEl.offsetTop;
          slaveEl = slaveEl.offsetParent as HTMLElement;
        }
      });
    }

    let mouseDownListener = (event: any) => {
      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      if (e.which === 3) {
        return
      }

      e.preventDefault()
      fakePinch = e.altKey
      calculateBounds()
      startMousing()

      let x = e.pageX - this.screen.bounds.x;
      let y = e.pageY - this.screen.bounds.y;
      let pressure = 0.5
      let scaled = this.scaler.coords(
        this.screen.bounds.w,
        this.screen.bounds.h,
        x,
        y,
        this.screen.rotation
      )

      this.prevCoords = {
        x: scaled.xP,
        y: scaled.yP,
      }

      // Original touch handling
      if (this.device.ios === true) {
        this.control.touchDownIos(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
        if (fakePinch) {
          this.control.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
      } else {
        this.control.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
        if (fakePinch) {
          this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
      }

      // Propagate to slave devices
      propagateToSlaves('touchDown', seq, 0, scaled.xP, scaled.yP, pressure);
      if (fakePinch) {
        propagateToSlaves('touchDown', nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
      }

      this.control.touchCommit(nextSeq())
      propagateToSlaves('touchCommit', seq);

      activateFinger(0, x, y, pressure)

      if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
          -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
      }

      this.element.addEventListener('mousemove', mouseMoveListener);
      this.element.addEventListener('mouseup', mouseUpListener);
      this.element.addEventListener('mouseleave', mouseUpListener);

      if (lastPossiblyBuggyMouseUpEvent &&
        lastPossiblyBuggyMouseUpEvent.timeStamp > e.timeStamp) {
        mouseUpListener(lastPossiblyBuggyMouseUpEvent)
      }
      else {
        lastPossiblyBuggyMouseUpEvent = null
      }
    }

    let mouseMoveListener = (event: any) => {
      let e = event
      if (e.originalEvent) {
        e = e.originalEvent
      }

      if (e.which === 3) {
        return
      }
      e.preventDefault()

      let addGhostFinger = !fakePinch && e.altKey
      let deleteGhostFinger = fakePinch && !e.altKey

      fakePinch = e.altKey

      let x = e.pageX - this.screen.bounds.x
      let y = e.pageY - this.screen.bounds.y
      let pressure = 0.5
      let scaled = this.scaler.coords(
        this.screen.bounds.w,
        this.screen.bounds.h,
        x,
        y,
        this.screen.rotation
      )

      this.control.touchMove(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
      propagateToSlaves('touchMove', seq, 0, scaled.xP, scaled.yP, pressure);

      if (addGhostFinger) {
        if (this.device.ios === true) {
          this.control.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        } else {
          this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
        propagateToSlaves('touchDown', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
      }
      else if (deleteGhostFinger) {
        this.control.touchUp(nextSeq(), 1)
        propagateToSlaves('touchUp', seq, 1);
      }
      else if (fakePinch) {
        this.control.touchMove(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        propagateToSlaves('touchMove', seq, 1, 1 - scaled.xP, 1 - scaled.yP, pressure);
      }

      this.control.touchCommit(nextSeq())
      propagateToSlaves('touchCommit', seq);

      activateFinger(0, x, y, pressure)

      if (deleteGhostFinger) {
        deactivateFinger(1)
      }
      else if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
          -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
      }
    }

    let mouseUpListener = (event: any) => {
      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      if (e.which === 3) {
        return
      }
      e.preventDefault()

      const x = e.pageX - this.screen.bounds.x
      const y = e.pageY - this.screen.bounds.y
      const pressure = 0.5
      const scaled = this.scaler.coords(
        this.screen.bounds.w,
        this.screen.bounds.h,
        x,
        y,
        this.screen.rotation,
        this.device.ios,
      )

      if (this.device.ios && this.device.ios === true) {
        this.control.touchMoveIos(
          scaled.xP,
          scaled.yP,
          this.prevCoords.x,
          this.prevCoords.y,
          pressure,
          nextSeq(),
          0
        )
        propagateToSlaves('touchMoveIos', seq, 0, scaled.xP, scaled.yP, pressure, this.prevCoords.x, this.prevCoords.y);
      }

      this.control.touchUp(nextSeq(), 0)
      propagateToSlaves('touchUp', seq, 0);

      if (fakePinch) {
        this.control.touchUp(nextSeq(), 1)
        propagateToSlaves('touchUp', seq, 1);
      }

      this.control.touchCommit(nextSeq())
      propagateToSlaves('touchCommit', seq);

      deactivateFinger(0)

      if (fakePinch) {
        deactivateFinger(1)
      }

      stopMousing()
    }

    let mouseUpBugWorkaroundListener = (e: any) => {
      lastPossiblyBuggyMouseUpEvent = e
    }

    let startMousing = () => {
      this.control.gestureStart(nextSeq())
      propagateToSlaves('gestureStart', seq);
      this.input.focus()
    }

    let stopMousing = () => {
      this.element.removeEventListener('mousemove', mouseMoveListener);
      this.element.removeEventListener('mouseup', mouseUpListener);
      this.element.removeEventListener('mouseleave', mouseUpListener);
      deactivateFingers()
      this.control.gestureStop(nextSeq())
      propagateToSlaves('gestureStop', seq);
    }

    let touchStartListener = (event: any) => {
      let e = event;
      e.preventDefault()

      if (e.originalEvent) {
        e = e.originalEvent
      }

      calculateBounds()

      if (e.touches.length === e.changedTouches.length) {
        startTouching()
      }

      let currentTouches = Object.create(null)
      let i, l

      for (i = 0, l = e.touches.length; i < l; ++i) {
        currentTouches[e.touches[i].identifier] = 1
      }

      let maybeLostTouchEnd = (id: any) => {
        return !(id in currentTouches)
      }

      if (Object.keys(slotted).some(maybeLostTouchEnd)) {
        Object.keys(slotted).forEach((id) => {
          slots.push(slotted[id])
          delete slotted[id]
        })
        slots.sort().reverse()
        this.control.touchReset(nextSeq())
        propagateToSlaves('touchReset', seq);
        deactivateFingers()
      }

      if (!slots.length) {
        throw new Error('Ran out of multitouch slots')
      }

      for (i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slots.pop()
        let x = touch.pageX - this.screen.bounds.x
        let y = touch.pageY - this.screen.bounds.y
        let pressure = touch.force || 0.5
        let scaled = this.scaler.coords(
          this.screen.bounds.w,
          this.screen.bounds.h,
          x,
          y,
          this.screen.rotation
        )

        slotted[touch.identifier] = slot

        if (this.device.ios === true) {
          this.control.touchDownIos(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        } else {
          this.control.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        }
        propagateToSlaves('touchDown', seq, slot, scaled.xP, scaled.yP, pressure);

        activateFinger(slot, x, y, pressure)
      }

      this.renderer.listen(this.element, 'touchmove', touchMoveListener);
      this.renderer.listen(this.element, 'touchend', touchEndListener);
      this.renderer.listen(this.element, 'touchleave', touchEndListener);

      this.control.touchCommit(nextSeq())
      propagateToSlaves('touchCommit', seq);
    }

    function touchMoveListener(event) {
      let e = event
      e.preventDefault()

      if (e.originalEvent) {
        e = e.originalEvent
      }

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        let x = touch.pageX - this.screen.bounds.x
        let y = touch.pageY - this.screen.bounds.y
        let pressure = touch.force || 0.5
        let scaled = this.scaler.coords(
          this.screen.bounds.w,
          this.screen.bounds.h,
          x,
          y,
          this.screen.rotation
        )

        this.control.touchMove(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        propagateToSlaves('touchMove', seq, slot, scaled.xP, scaled.yP, pressure);
        activateFinger(slot, x, y, pressure)
      }

      this.control.touchCommit(nextSeq())
      propagateToSlaves('touchCommit', seq);
    }

    let touchEndListener = (event: any) => {
      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      let foundAny = false

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        if (typeof slot === 'undefined') {
          continue
        }
        delete slotted[touch.identifier]
        slots.push(slot)
        this.control.touchUp(nextSeq(), slot)
        propagateToSlaves('touchUp', seq, slot);
        deactivateFinger(slot)
        foundAny = true
      }

      if (foundAny) {
        this.control.touchCommit(nextSeq())
        propagateToSlaves('touchCommit', seq);
        if (!e.touches.length) {
          stopTouching()
        }
      }
    }

    let startTouching = () => {
      this.control.gestureStart(nextSeq())
      propagateToSlaves('gestureStart', seq);
    }

    let stopTouching = () => {
      this.element.removeEventListener('touchmove', touchMoveListener);
      this.element.removeEventListener('touchend', touchEndListener);
      this.element.removeEventListener('touchleave', touchEndListener);
      deactivateFingers()
      this.control.gestureStop(nextSeq())
      propagateToSlaves('gestureStop', seq);
    }

    this.renderer.listen(this.element, 'touchstart', touchStartListener);
    this.renderer.listen(this.element, 'mousedown', mouseDownListener);
    this.renderer.listen(this.element, 'mouseup', mouseUpBugWorkaroundListener);

    createSlots()
  }

  applyTouchToSlaves(type: 'down' | 'move' | 'up', seq: number, slot?: number, xP?: number, yP?: number, pressure?: number) {

    //for device 1
    if (this.device1 && this.screen1) {
      const coords1 = this.scaler1.coords(
        this.screen1.bounds.w,
        this.screen1.bounds.h,
        xP * this.screen1.bounds.w,
        yP * this.screen1.bounds.h,
        this.screen1.rotation
      );

      if (this.device1.ios) {
        if (type === 'down') this.control1.touchDownIos(seq, slot, coords1.xP, coords1.yP, pressure);
        if (type === 'move') this.control1.touchMoveIos(coords1.xP, coords1.yP, xP, yP, pressure, seq, slot);
        if (type === 'up') this.control1.touchUp(seq, slot);
      } else {
        if (type === 'down') this.control1.touchDown(seq, slot, coords1.xP, coords1.yP, pressure);
        if (type === 'move') this.control1.touchMove(seq, slot, coords1.xP, coords1.yP, pressure);
        if (type === 'up') this.control1.touchUp(seq, slot);
      }

      this.control1.touchCommit(seq);
    }

    //for device 2
    if (this.device2 && this.screen2) {
      const coords2 = this.scaler2.coords(
        this.screen2.bounds.w,
        this.screen2.bounds.h,
        xP * this.screen2.bounds.w,
        yP * this.screen2.bounds.h,
        this.screen2.rotation
      );

      if (this.device2.ios) {
        if (type === 'down') this.control2.touchDownIos(seq, slot, coords2.xP, coords2.yP, pressure);
        if (type === 'move') this.control2.touchMoveIos(coords2.xP, coords2.yP, xP, yP, pressure, seq, slot);
        if (type === 'up') this.control2.touchUp(seq, slot);
      } else {
        if (type === 'down') this.control2.touchDown(seq, slot, coords2.xP, coords2.yP, pressure);
        if (type === 'move') this.control2.touchMove(seq, slot, coords2.xP, coords2.yP, pressure);
        if (type === 'up') this.control2.touchUp(seq, slot);
      }

      this.control2.touchCommit(seq);
    }

    //for device 3
    if (this.device3 && this.screen3) {
      const coords3 = this.scaler3.coords(
        this.screen3.bounds.w,
        this.screen3.bounds.h,
        xP * this.screen3.bounds.w,
        yP * this.screen3.bounds.h,
        this.screen3.rotation
      );

      if (this.device3.ios) {
        if (type === 'down') this.control3.touchDownIos(seq, slot, coords3.xP, coords3.yP, pressure);
        if (type === 'move') this.control3.touchMoveIos(coords3.xP, coords3.yP, xP, yP, pressure, seq, slot);
        if (type === 'up') this.control3.touchUp(seq, slot);
      } else {
        if (type === 'down') this.control3.touchDown(seq, slot, coords3.xP, coords3.yP, pressure);
        if (type === 'move') this.control3.touchMove(seq, slot, coords3.xP, coords3.yP, pressure);
        if (type === 'up') this.control3.touchUp(seq, slot);
      }

      this.control3.touchCommit(seq);
    }

    //for device 4
    if (this.device4 && this.screen4) {
      const coords4 = this.scaler4.coords(
        this.screen4.bounds.w,
        this.screen4.bounds.h,
        xP * this.screen4.bounds.w,
        yP * this.screen4.bounds.h,
        this.screen4.rotation
      );

      if (this.device4.ios) {
        if (type === 'down') this.control4.touchDownIos(seq, slot, coords4.xP, coords4.yP, pressure);
        if (type === 'move') this.control4.touchMoveIos(coords4.xP, coords4.yP, xP, yP, pressure, seq, slot);
        if (type === 'up') this.control4.touchUp(seq, slot);
      } else {
        if (type === 'down') this.control4.touchDown(seq, slot, coords4.xP, coords4.yP, pressure);
        if (type === 'move') this.control4.touchMove(seq, slot, coords4.xP, coords4.yP, pressure);
        if (type === 'up') this.control4.touchUp(seq, slot);
      }

      this.control4.touchCommit(seq);
    }
  }


  touchHandlingMethod1() {
    let slots = [];
    let slotted = Object.create(null);
    let fingers = [];
    let seq = -1;
    let cycle = 100;
    let fakePinch = false;
    let lastPossiblyBuggyMouseUpEvent: any = 0;

    let nextSeq = () => {
      return ++seq >= cycle ? (seq = 0) : seq
    }

    let createSlots = () => {
      // The reverse order is important because slots and fingers are in
      // opposite sort order. Anyway don't change anything here unless
      // you understand what it does and why.
      for (let i = 9; i >= 0; --i) {
        let finger = createFinger(i);
        this.element1.append(finger);
        slots.push(i);
        fingers.unshift(finger);
      }
    }

    let activateFinger = (index: any, x: any, y: any, pressure: any) => {
      let scale = 0.5 + pressure
      fingers[index].classList.add('active')
      fingers[index].style[this.cssTransform1] =
        'translate3d(' + x + 'px,' + y + 'px,0) ' +
        'scale(' + scale + ',' + scale + ')'
    }

    let deactivateFinger = (index: any) => {
      fingers[index].classList.remove('active')
    }

    let deactivateFingers = () => {
      for (let i = 0, l = fingers.length; i < l; ++i) {
        fingers[i].classList.remove('active')
      }
    }

    let createFinger = (index: any) => {
      let el = document.createElement('span')
      el.className = 'finger finger-' + index
      return el;
    }

    let calculateBounds = () => {

      let el = this.element1 as HTMLElement;

      this.screen1.bounds.w = el.offsetWidth
      this.screen1.bounds.h = el.offsetHeight
      this.screen1.bounds.x = 0
      this.screen1.bounds.y = 0

      while (el.offsetParent) {
        this.screen1.bounds.x += el.offsetLeft
        this.screen1.bounds.y += el.offsetTop
        el = el.offsetParent as HTMLElement;
      }
    }

    let mouseDownListener = (event: any) => {

      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }

      e.preventDefault()

      fakePinch = e.altKey

      calculateBounds()
      startMousing()

      let x = e.pageX - this.screen1.bounds.x;
      let y = e.pageY - this.screen1.bounds.y;
      let pressure = 0.5
      let scaled = this.scaler1.coords(
        this.screen1.bounds.w
        , this.screen1.bounds.h
        , x
        , y
        , this.screen1.rotation
      )
      //ios change
      this.prevCoords1 = {
        x: scaled.xP,
        y: scaled.yP,
      }
      //ios change

      // ios change
      if (this.device1.ios === true) {
        this.control1.touchDownIos(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
        if (fakePinch) {
          this.control1.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
      } else {
        this.control1.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
        if (fakePinch) {
          this.control1.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
      }
      // ios change

      // this.control1.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure);

      // if (fakePinch) {
      //   this.control1.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP,
      //     pressure)
      // }

      this.control1.touchCommit(nextSeq())

      activateFinger(0, x, y, pressure)

      if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen1.bounds.x + this.screen1.bounds.w,
          -e.pageY + this.screen1.bounds.y + this.screen1.bounds.h, pressure);
      }

      this.element1.addEventListener('mousemove', mouseMoveListener);
      this.element1.addEventListener('mouseup', mouseUpListener);
      this.element1.addEventListener('mouseleave', mouseUpListener);

      // this.renderer.listen(this.element1, 'mousemove', mouseMoveListener);
      // this.renderer.listen(this.element1, 'mouseup', mouseUpListener);
      // this.renderer.listen(this.element1, 'mouseleave', mouseUpListener);
      // this.element1.bind('mousemove', mouseMoveListener)
      // $document.bind('mouseup', mouseUpListener)
      // $document.bind('mouseleave', mouseUpListener)

      if (lastPossiblyBuggyMouseUpEvent &&
        lastPossiblyBuggyMouseUpEvent.timeStamp > e.timeStamp) {
        // We got mouseup before mousedown. See mouseUpBugWorkaroundListener
        // for details.
        mouseUpListener(lastPossiblyBuggyMouseUpEvent)
      }
      else {
        lastPossiblyBuggyMouseUpEvent = null
      }
    }

    let mouseMoveListener = (event: any) => {

      let e = event
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }
      e.preventDefault()

      let addGhostFinger = !fakePinch && e.altKey
      let deleteGhostFinger = fakePinch && !e.altKey

      fakePinch = e.altKey

      let x = e.pageX - this.screen1.bounds.x
      let y = e.pageY - this.screen1.bounds.y
      let pressure = 0.5
      let scaled = this.scaler1.coords(
        this.screen1.bounds.w
        , this.screen1.bounds.h
        , x
        , y
        , this.screen1.rotation
      )

      this.control1.touchMove(nextSeq(), 0, scaled.xP, scaled.yP, pressure)

      if (addGhostFinger) {
        //ios change
        if (this.device1.ios === true) {
          this.control1.touchDownIos(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        } else {
          this.control1.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
        //ios change
        // this.control1.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
      }
      else if (deleteGhostFinger) {
        this.control1.touchUp(nextSeq(), 1)
      }
      else if (fakePinch) {
        this.control1.touchMove(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
      }

      this.control1.touchCommit(nextSeq())

      activateFinger(0, x, y, pressure)

      if (deleteGhostFinger) {
        deactivateFinger(1)
      }
      else if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen1.bounds.x + this.screen1.bounds.w,
          -e.pageY + this.screen1.bounds.y + this.screen1.bounds.h, pressure);
      }
    }

    let mouseUpListener = (event: any) => {


      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }
      e.preventDefault()

      //ios change
      const x = e.pageX - this.screen1.bounds.x
      const y = e.pageY - this.screen1.bounds.y
      const pressure = 0.5
      const scaled = this.scaler1.coords(
        this.screen1.bounds.w,
        this.screen1.bounds.h,
        x,
        y,
        this.screen1.rotation,
        this.device1.ios,
      )
      // (Math.abs(prevCoords1.x - scaled.xP) >= 0.1|| Math.abs(prevCoords1.y - scaled.yP) >= 0.1)
      if (this.device1.ios && this.device1.ios === true) { // TODO: can be non boolean?
        this.control1.touchMoveIos(
          scaled.xP,
          scaled.yP,
          this.prevCoords1.x,
          this.prevCoords1.y,
          pressure,
          nextSeq(),
          0
        )
      }
      //ios change

      this.control1.touchUp(nextSeq(), 0)

      if (fakePinch) {
        this.control1.touchUp(nextSeq(), 1)
      }

      this.control1.touchCommit(nextSeq())

      deactivateFinger(0)

      if (fakePinch) {
        deactivateFinger(1)
      }

      stopMousing()
    }

    /**
     * Do NOT remove under any circumstances. Currently, in the latest
     * Safari (Version 8.0 (10600.1.25)), if an input field is focused
     * while we do a tap click on an MBP trackpad ("Tap to click" in
     * Settings), it sometimes causes the mouseup event to trigger before
     * the mousedown event (but event.timeStamp will be correct). It
     * doesn't happen in any other browser. The following minimal test
     * case triggers the same behavior (although less frequently). Keep
     * tapping and you'll eventually see see two mouseups in a row with
     * the same counter value followed by a mousedown with a new counter
     * value. Also, when the bug happens, the cursor in the input field
     * stops blinking. It may take up to 300 attempts to spot the bug on
     * a MacBook Pro (Retina, 15-inch, Mid 2014).
     *
     *     <!doctype html>
     *
     *     <div id="touchable"
     *       style="width: 100px; height: 100px; background: green"></div>
     *     <input id="focusable" type="text" />
     *
     *     <script>
     *     let touchable = document.getElementById('touchable')
     *       , focusable = document.getElementById('focusable')
     *       , counter = 0
     *
     *     function mousedownListener(e) {
     *       counter += 1
     *       console.log('mousedown', counter, e, e.timeStamp)
     *       e.preventDefault()
     *     }
     *
     *     function mouseupListener(e) {
     *       e.preventDefault()
     *       console.log('mouseup', counter, e, e.timeStamp)
     *       focusable.focus()
     *     }
     *
     *     touchable.addEventListener('mousedown', mousedownListener, false)
     *     touchable.addEventListener('mouseup', mouseupListener, false)
     *     </script>
     *
     * I believe that the bug is caused by some kind of a race condition
     * in Safari. Using a textarea or a focused contenteditable does not
     * get rid of the bug. The bug also happens if the text field is
     * focused manually by the user (not with .focus()).
     *
     * It also doesn't help if you .blur() before .focus().
     *
     * So basically we'll just have to store the event on mouseup and check
     * if we should do the browser's job in the mousedown handler.
     */

    let mouseUpBugWorkaroundListener = (e: any) => {
      lastPossiblyBuggyMouseUpEvent = e
    }

    let startMousing = () => {
      this.control1.gestureStart(nextSeq())
      this.input1.focus()
    }

    let stopMousing = () => {
      this.element1.removeEventListener('mousemove', mouseMoveListener);
      this.element1.removeEventListener('mouseup', mouseUpListener);
      this.element1.removeEventListener('mouseleave', mouseUpListener);
      // this.element1.unbind('mousemove', mouseMoveListener)
      // $document.unbind('mouseup', mouseUpListener)
      // $document.unbind('mouseleave', mouseUpListener)
      deactivateFingers()
      this.control1.gestureStop(nextSeq())
    }

    let touchStartListener = (event: any) => {
      let e = event;
      e.preventDefault()

      //Make it jQuery compatible also
      if (e.originalEvent) {
        e = e.originalEvent
      }

      calculateBounds()

      if (e.touches.length === e.changedTouches.length) {
        startTouching()
      }

      let currentTouches = Object.create(null)
      let i, l

      for (i = 0, l = e.touches.length; i < l; ++i) {
        currentTouches[e.touches[i].identifier] = 1
      }

      let maybeLostTouchEnd = (id: any) => {
        return !(id in currentTouches)
      }

      // We might have lost a touchend event due to various edge cases
      // (literally) such as dragging from the bottom of the screen1 so that
      // the control1 center appears. If so, let's ask for a reset.
      if (Object.keys(slotted).some(maybeLostTouchEnd)) {
        Object.keys(slotted).forEach((id) => {
          slots.push(slotted[id])
          delete slotted[id]
        })
        slots.sort().reverse()
        this.control1.touchReset(nextSeq())
        deactivateFingers()
      }

      if (!slots.length) {
        // This should never happen but who knows...
        throw new Error('Ran out of multitouch slots')
      }

      for (i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slots.pop()
        let x = touch.pageX - this.screen1.bounds.x
        let y = touch.pageY - this.screen1.bounds.y
        let pressure = touch.force || 0.5
        let scaled = this.scaler1.coords(
          this.screen1.bounds.w
          , this.screen1.bounds.h
          , x
          , y
          , this.screen1.rotation
        )


        slotted[touch.identifier] = slot
        // ios change
        if (this.device1.ios === true) { // TODO: can be non boolean?
          this.control1.touchDownIos(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        } else {
          this.control1.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        }
        // ios change
        // this.control1.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        activateFinger(slot, x, y, pressure)
      }

      this.renderer.listen(this.element1, 'touchmove', touchMoveListener);
      this.renderer.listen(this.element1, 'touchend', touchEndListener);
      this.renderer.listen(this.element1, 'touchleave', touchEndListener);
      // this.element1.bind('touchmove', touchMoveListener)
      // $document.bind('touchend', touchEndListener)
      // $document.bind('touchleave', touchEndListener)

      this.control1.touchCommit(nextSeq())
    }

    function touchMoveListener(event) {

      let e = event
      e.preventDefault()

      if (e.originalEvent) {
        e = e.originalEvent
      }

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        let x = touch.pageX - this.screen1.bounds.x
        let y = touch.pageY - this.screen1.bounds.y
        let pressure = touch.force || 0.5
        let scaled = this.scaler1.coords(
          this.screen1.bounds.w
          , this.screen1.bounds.h
          , x
          , y
          , this.screen1.rotation
        )

        this.control1.touchMove(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        activateFinger(slot, x, y, pressure)
      }

      this.control1.touchCommit(nextSeq())
    }

    let touchEndListener = (event: any) => {
      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      let foundAny = false

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        if (typeof slot === 'undefined') {
          // We've already disposed of the contact. We may have gotten a
          // touchend event for the same contact twice.
          continue
        }
        delete slotted[touch.identifier]
        slots.push(slot)
        this.control1.touchUp(nextSeq(), slot)
        deactivateFinger(slot)
        foundAny = true
      }

      if (foundAny) {
        this.control1.touchCommit(nextSeq())
        if (!e.touches.length) {
          stopTouching()
        }
      }
    }

    let startTouching = () => {
      this.control1.gestureStart(nextSeq())
    }

    let stopTouching = () => {
      this.element1.removeEventListener('touchmove', touchMoveListener);
      this.element1.removeEventListener('touchend', touchEndListener);
      this.element1.removeEventListener('touchleave', touchEndListener);
      // this.element1.unbind('touchmove', touchMoveListener)
      // $document.unbind('touchend', touchEndListener)
      // $document.unbind('touchleave', touchEndListener)
      deactivateFingers()
      this.control1.gestureStop(nextSeq())
    }

    this.renderer.listen(this.element1, 'touchstart', touchStartListener);
    this.renderer.listen(this.element1, 'mousedown', mouseDownListener);
    this.renderer.listen(this.element1, 'mouseup', mouseUpBugWorkaroundListener);
    // this.element1.on('touchstart', touchStartListener)
    // this.element1.on('mousedown', mouseDownListener)
    // this.element1.on('mouseup', mouseUpBugWorkaroundListener)

    createSlots()
  }

  keyboardHandlingMethod() {
    let isChangeCharsetKey = (e: any) => {
      // Add any special key here for changing charset

      // Chrome/Safari/Opera
      if (
        // Mac | Kinesis keyboard | Karabiner | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0010' ||

        // Mac | MacBook Pro keyboard | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0020' ||

        // Win | Lenovo X230 keyboard | Alt+Latin key
        e.keyCode === 246 && e.keyIdentifier === 'U+00F6' ||

        // Win | Lenovo X230 keyboard | Convert key
        e.keyCode === 28 && e.keyIdentifier === 'U+001C'
      ) {
        return true
      }

      // Firefox
      switch (e.key) {
        case 'Convert': // Windows | Convert key
        case 'Alphanumeric': // Mac | Latin key
        case 'RomanCharacters': // Windows/Mac | Latin key
        case 'KanjiMode': // Windows/Mac | Kana key
          return true
      }

      return false
    }

    let handleSpecialKeys = (e: any) => {
      if (isChangeCharsetKey(e)) {
        e.preventDefault();
        this.control.keyPress('switch_charset');
        return true;
      }
      return false;
    }

    this.listeners['keydownListener'] = (e: any) => {
      // Prevent tab from switching focus to the next element, we only want
      // that to happen on the device1 side.

      if (e.code == "ArrowLeft") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_left" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_left" })
      }
      if (e.code == "ArrowRight") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_right" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_right" })
      }
      if (e.code == "ArrowUp") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_up" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_up" })
      }
      if (e.code == "ArrowDown") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_down" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_down" })
      }
      if (e.code == "Enter") {
        this.control.sendEnter('input.keyDown', { 'key': "enter" })
        this.control.sendEnter('input.keyUp', { 'key': "enter" })
      }
      if (e.code == "Backspace") {
        this.control.sendBackspace('input.keyDown', { 'key': "del" });
        this.control.sendBackspace('input.keyUp', { 'key': "del" });
      }
      if (e.code == "Delete") {
        this.control.sendDelete('input.keyDown', { 'key': "forward_del" });
        this.control.sendDelete('input.keyUp', { 'key': "forward_del" });
      }
      if (e.keyCode === 9) {
        e.preventDefault();
      }
      this.control.keyDown(e.keyCode)
    }

    this.listeners['keyupListener'] = (e: any) => {
      if (!handleSpecialKeys(e)) {
        this.control.keyUp(e.keyCode);
      }
    }

    this.listeners['pasteListener'] = (e: any) => {
      // Prevent value change or the input event sees it. This way we get
      // the real value instead of any "\n" -> " " conversions we might see
      // in the input value.
      e.preventDefault();
      this.control.paste(e.clipboardData.getData('text/plain'))
    }

    this.listeners['copyListener'] = (e: any) => {
      e.preventDefault()
      // This is asynchronous and by the time it returns we will no longer
      // have access to setData(). In other words it doesn't work. Currently
      // what happens is that on the first copy, it will attempt to fetch
      // the clipboard contents. Only on the second copy will it actually
      // copy that to the clipboard.
      this.control.getClipboardContent();
      if (this.control.clipboardContent) {
        e.clipboardData.setData('text/plain', this.control.clipboardContent);
      }
    }

    this.listeners['inputListener'] = (e: any) => {
      // Why use the input event if we don't let it handle pasting? The
      // reason is that on latest Safari (Version 8.0 (10600.1.25)), if
      // you use the "Romaji" Kotoeri input method, we'll never get any
      // keypress events. It also causes us to lose the very first keypress
      // on the page. Currently I'm not sure if we can fix that one.
      //check this <-----------------------------------------------------
      this.control.sendKeyInput('input.type', e)


      // this.control.type(this.value);
      // this.value = ''
    }
    this.input.addEventListener('keydown', this.listeners['keydownListener']);
    this.input.addEventListener('keyup', this.listeners['keyupListener']);
    this.input.addEventListener('input', this.listeners['inputListener']);
    this.input.addEventListener('paste', this.listeners['pasteListener']);
    this.input.addEventListener('copy', this.listeners['copyListener']);

    // this.input.bind('keydown', keydownListener);
    // this.input.bind('keyup', keyupListener);
    // this.input.bind('input', inputListener);
    // this.input.bind('paste', pasteListener);
    // this.input.bind('copy', copyListener);
  }

  keyboardHandlingMethod1() {
    let isChangeCharsetKey = (e: any) => {
      // Add any special key here for changing charset

      // Chrome/Safari/Opera
      if (
        // Mac | Kinesis keyboard | Karabiner | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0010' ||

        // Mac | MacBook Pro keyboard | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0020' ||

        // Win | Lenovo X230 keyboard | Alt+Latin key
        e.keyCode === 246 && e.keyIdentifier === 'U+00F6' ||

        // Win | Lenovo X230 keyboard | Convert key
        e.keyCode === 28 && e.keyIdentifier === 'U+001C'
      ) {
        return true
      }

      // Firefox
      switch (e.key) {
        case 'Convert': // Windows | Convert key
        case 'Alphanumeric': // Mac | Latin key
        case 'RomanCharacters': // Windows/Mac | Latin key
        case 'KanjiMode': // Windows/Mac | Kana key
          return true
      }

      return false
    }

    let handleSpecialKeys = (e: any) => {
      if (isChangeCharsetKey(e)) {
        e.preventDefault();
        this.control1.keyPress('switch_charset');
        return true;
      }
      return false;
    }

    this.listeners1['keydownListener'] = (e: any) => {
      // Prevent tab from switching focus to the next element1, we only want
      // that to happen on the device1 side.

      if (e.code == "ArrowLeft") {
        this.control1.sendArrowKeys('input.keyDown', { 'key': "dpad_left" })
        this.control1.sendArrowKeys('input.keyUp', { 'key': "dpad_left" })
      }
      if (e.code == "ArrowRight") {
        this.control1.sendArrowKeys('input.keyDown', { 'key': "dpad_right" })
        this.control1.sendArrowKeys('input.keyUp', { 'key': "dpad_right" })
      }
      if (e.code == "ArrowUp") {
        this.control1.sendArrowKeys('input.keyDown', { 'key': "dpad_up" })
        this.control1.sendArrowKeys('input.keyUp', { 'key': "dpad_up" })
      }
      if (e.code == "ArrowDown") {
        this.control1.sendArrowKeys('input.keyDown', { 'key': "dpad_down" })
        this.control1.sendArrowKeys('input.keyUp', { 'key': "dpad_down" })
      }
      if (e.code == "Enter") {
        this.control1.sendEnter('input.keyDown', { 'key': "enter" })
        this.control1.sendEnter('input.keyUp', { 'key': "enter" })
      }
      if (e.code == "Backspace") {
        this.control1.sendBackspace('input.keyDown', { 'key': "del" });
        this.control1.sendBackspace('input.keyUp', { 'key': "del" });
      }
      if (e.code == "Delete") {
        this.control1.sendDelete('input.keyDown', { 'key': "forward_del" });
        this.control1.sendDelete('input.keyUp', { 'key': "forward_del" });
      }
      if (e.keyCode === 9) {
        e.preventDefault();
      }
      this.control1.keyDown(e.keyCode)
    }

    this.listeners1['keyupListener'] = (e: any) => {
      if (!handleSpecialKeys(e)) {
        this.control1.keyUp(e.keyCode);
      }
    }

    this.listeners1['pasteListener'] = (e: any) => {
      // Prevent value change or the input event sees it. This way we get
      // the real value instead of any "\n" -> " " conversions we might see
      // in the input value.
      e.preventDefault();
      this.control1.paste(e.clipboardData.getData('text/plain'))
    }

    this.listeners1['copyListener'] = (e: any) => {
      e.preventDefault()
      // This is asynchronous and by the time it returns we will no longer
      // have access to setData(). In other words it doesn't work. Currently
      // what happens is that on the first copy, it will attempt to fetch
      // the clipboard contents. Only on the second copy will it actually
      // copy that to the clipboard.
      this.control1.getClipboardContent();
      if (this.control1.clipboardContent) {
        e.clipboardData.setData('text/plain', this.control1.clipboardContent);
      }
    }

    this.listeners1['inputListener'] = (e: any) => {
      // Why use the input event if we don't let it handle pasting? The
      // reason is that on latest Safari (Version 8.0 (10600.1.25)), if
      // you use the "Romaji" Kotoeri input method, we'll never get any
      // keypress events. It also causes us to lose the very first keypress
      // on the page. Currently I'm not sure if we can fix that one.
      //check this <-----------------------------------------------------
      this.control1.sendKeyInput('input.type', e)


      // this.control.type(this.value);
      // this.value = ''
    }
    this.input1.addEventListener('keydown', this.listeners1['keydownListener']);
    this.input1.addEventListener('keyup', this.listeners1['keyupListener']);
    this.input1.addEventListener('input', this.listeners1['inputListener']);
    this.input1.addEventListener('paste', this.listeners1['pasteListener']);
    this.input1.addEventListener('copy', this.listeners1['copyListener']);

    // this.input1.bind('keydown', keydownListener);
    // this.input1.bind('keyup', keyupListener);
    // this.input1.bind('input', inputListener);
    // this.input1.bind('paste', pasteListener);
    // this.input1.bind('copy', copyListener);
  }
}
